// SettingsPage.tsx · v12.10.28 (#2205 Identity Main-location note removed; #2206 sidebar "Additional locations"; #2207 Hours footnote inside the section padding) · 2026-11-02 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.26 (#2141 Organization › Locations after Identity (own rights row); Hours & locale location pills; Identity note) · 2026-10-30 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.26 (#T154 Text Messaging area after Communication; Call Handling › Texts on calls in the sidebar + its rights row) · 2026-10-30 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.25 (#2079 a menu entry jumps to the card with its title, spy paused during the scroll; #2115 rights keys = sidebar: Keypad menus, Reliability Failure message + External systems, Personalization five rows) · 2026-10-30 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.23 (#2012 Call Handling sections: Conversation flow · Recording · Keypad menus · Hold · Processing; search finds Keypad menus + Silent caller) · 2026-10-29 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.18 (#1866 the unsaved bar counts the workflow's changed parts, Save disabled while saving) · 2026-10-22 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.17 (#1758 Automatic status has its own nav dot) · 2026-10-16 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.16 (T113 Repeat callers / Automatic status in the Personalization menu) · 2026-10-14 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.15 (#1666 search finds Voicemail details) · 2026-10-13 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.11.1 (#1479 six holidays pre-ticked) · 2026-10-09
// SettingsPage.tsx · v12.10.11 (#1457 empty Primary language says where languages are turned on) · 2026-10-08
// SettingsPage.tsx · v12.10.11 (#1440 saving one Organization section keeps the other sections' unsaved edits) · 2026-10-08 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.10.1 (#1428 no unsaved bar behind an open workflow card drawer) · 2026-10-08 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.10 (#1409 Workflow page line) · 2026-10-08 · VoiceSpectrum AI
// SettingsPage.tsx · v12.10.9.4 (#1335 sticky unsaved bar + F7 dialogs) · 2026-10-07
// VoiceSpectrum.Web.T2 · SettingsPage · v12.10.9.3 (#1328 the Security card opens Security with three tiles - Platform, Users, User groups; each tile opens its screen and the breadcrumb returns to the tiles) · 2026-10-07
// VoiceSpectrum.Web.T2 · v12.10.9.1 (#1291 the Security card lists Platform · Users · User groups) · 2026-10-06
// VoiceSpectrum.Web.T2 · v12.10.9 (Security Phase 1 – #1258/#1259/#1260/#1261) · 2026-10-06
// v12.10.9 (#1258-#1261): the Platform area is replaced by SECURITY (lock icon) whose left sub-nav loads PAGES - Platform ·
//   Users · User groups (pages/security/SecurityArea). PlatformSections.tsx (idle timeout only) is no longer rendered.
//   Areas / sections the signed-in person has no access to are hidden (lib/useAccess: GET /api/t2/security/me -> access,
//   keys 's:<Area>:<Section>'). /configuration/platform still lands here (-> Security); /configuration/account opens Your account.
// v12.10.8.1 (#1229): the Vocabulary area description is shorter.
// v12.10.8 (#1160): a new Settings area, VOCABULARY (Fields, Lists) - out of Personalization, which keeps its four. (#1190): AI Agent loses Identity extraction.
// v12.9.26 (#949): Primary language beside Address (Address one column). (#969): Personalization > Agent phrases removed - the lines moved to Workflow > lane 7 'Phrases'.
// v12.4.16 (#500): Personalization gains a seventh section, Lists - the nav list, the sub-section key order
//                   and the search keywords that reach it.
// v12.2.42.0 (#236): Vocabulary moved OUT of Organization to Personalization (see PersonalizationSections).
// VoiceSpectrum.Web.T2 - Settings / Organization - v12.2.38.0 (#112 search works inside a section via jump list; #203 nav highlights first/matching section)
// VoiceSpectrum.Web.T2 - Settings / Organization - v12.2.20.0
// v12.2.20.0 (#142): updateHour seeds default open/close times when a day is toggled open, fixing the
// HTTP 400 on saving a newly-enabled day (e.g. Saturday) whose time inputs only showed a display-fallback.
// v12.1.30.0 (GG1): the "Choose an area" search now live-filters the area grid cards (matches area
// title + subtitle + section names, case-insensitive). GG2/Q are CSS-side (settings-organization.css).
// v11.8.8.1 (AAR7/AAR8/AAR12): AI Agent nav-label casing + page subtitle; AI Agent per-section
// dirty state wired into the shell (area/section red dots + "Save all changes" / "Discard draft").
// Sticky header (search + title + global actions), magnifier search, config-areas accordion nav,
// real card icons, full holiday list, Logo/URL in the right column. Renders inside shared Shell.
import { ChangeEvent, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { langLabel } from '../components/PromptEditor';   // v12.9.22 (#884)
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api, { mediaUrl } from '../lib/api';
import { useAuth } from '../lib/auth';
import WorkflowModalSnapshotPage, { type WorkflowSnapshotState } from './WorkflowModalSnapshotPage';
import AiAgentSections, { AiAgentState, AiDirtyMap, AiSectionKey } from './AiAgentSections';
import CallHandlingSections, { CallHandlingState, CallDirtyMap, CallSectionKey } from './CallHandlingSections';
import ReliabilitySections, { ReliabilityState, ReliabilityDirtyMap, ReliabilitySectionKey } from './ReliabilitySections';
// v12.3.11 (#305): Organization saves confirm with the canonical bottom-centre toast, not only an inline line.
import { toast } from '../lib/toast';
import KnowledgeBaseSections, { KnowledgeBaseState, KbDirtyMap, KbSectionKey } from './KnowledgeBaseSections';
// v12.10.9: PlatformSections (Settings › Platform, idle timeout only) is superseded by Security › Platform - not rendered.
import SecurityArea, { SECURITY_PAGES, useSecurityPages, type SecurityPageKey, type SecurityState } from './security/SecurityArea';
import { Ic } from '../components/security/ui';   // v12.10.9.3 (#1328) tile icons
import { YourAccountHost } from '../components/security/YourAccountDrawer';
import { useAccess } from '../lib/useAccess';
import CommunicationSections, { CommunicationState, CommunicationSectionKey } from './CommunicationSections';
import TextMessagingSections, { TextMessagingState, TextingSectionKey } from './TextMessagingSections';   // v12.10.26 (#T154)
import PersonalizationSections, { PersonalizationState, PzDirtyMap, PzSectionKey } from './PersonalizationSections';
import IntegrationsSections, { IntegrationsState, IntDirtyMap, IntSectionKey } from './IntegrationsSections';
import AddressAutocomplete from '../components/AddressAutocomplete';
import { useNavGuard } from '../lib/navGuard';
import './settings-organization.css';
import UnsavedBar, { changesText, useDirtyCards } from '../components/settings/UnsavedBar';   // v12.10.9.4 (#1335)
import { LocationsCard, LocationPills, useLocations, LOCATIONS_KEY, type LocationHour } from './organization/LocationsSection';   // v12.10.26 (#2141)

type SettingsArea = 'grid' | 'organization' | 'ai' | 'call' | 'reliability' | 'workflow' | 'knowledge' | 'security' | 'communication' | 'texting' | 'personalization' | 'vocabulary' | 'integrations';   // v12.10.26 (#T154): + texting
type OrgSection = 'identity' | 'locations' | 'hours' | 'holidays';   // v12.10.26 (#2141): Locations after Identity

interface OrganizationIdentity {
  legalName: string;
  displayName: string;
  websiteUrl?: string | null;
  logoIconPath?: string | null;
  logoFullPath?: string | null;
  addressText?: string | null;
  addressLatitude?: number | null;
  addressLongitude?: number | null;
  addressVerified?: boolean;
  primaryEmail?: string | null;
  primaryPhone?: string | null;
  primaryContactName?: string | null;
  primaryContactRole?: string | null;
  // v12.9.22 (#884): primary language, carried as a code ("en"); enabledLanguages is GET-only and
  // arrives primary-first. The SET is chosen on the AI Agent screen - this control only says which leads.
  primaryLanguage?: string | null;
  enabledLanguages?: string[] | null;
  industry: string;
  industryOther?: string | null;
  timezoneId: string;
  tenantUrl?: string | null;
  slug?: string | null;
}

interface BusinessHour {
  dayOfWeek: number;
  isOpen: boolean;
  openTime?: string | null;
  closeTime?: string | null;
  breakEnabled: boolean;
  breakStartTime?: string | null;
  breakEndTime?: string | null;
}

interface HolidayItem {
  id?: number | null;
  year: number;
  date: string;
  name: string;
  type: string;
  sourceKey?: string | null;
  observed: boolean;
}

interface HolidayPayload {
  years: number[];
  items: HolidayItem[];
}

interface OrganizationSettings {
  identity: OrganizationIdentity;
  hours: BusinessHour[];
  holidays: HolidayPayload;
}

const SETTINGS_AREAS: { id: Exclude<SettingsArea, 'grid'>; title: string; subtitle: string }[] = [
  { id: 'organization', title: 'Organization', subtitle: 'Identity, locations, hours, holidays' },   // v12.10.26 (#2141)
  { id: 'ai', title: 'AI Agent', subtitle: 'Phone, agent details, languages & voices' },
  { id: 'call', title: 'Call Handling', subtitle: 'Conversation flow, recording, keypad menus, hold & processing' },   // v12.10.23 (#2012)
  { id: 'reliability', title: 'Reliability', subtitle: 'Retries, timeouts, and failure fallbacks' },
  { id: 'workflow', title: 'Workflow', subtitle: 'Greeting, classification, routing' },
  { id: 'knowledge', title: 'Knowledge Base', subtitle: 'Sources the assistant can answer from' },
  { id: 'security', title: 'Security', subtitle: 'Sign-in, sessions, users, user groups' },   // v12.10.9 (#1258): replaces Platform
  { id: 'communication', title: 'Communication', subtitle: 'Outbound email (SMTP) and SMS testing' },
  { id: 'texting', title: 'Text Messaging', subtitle: 'Patients who text the practice first - workflow, automatic reply' },   // v12.10.26 (#T154 Q11 TC6): after Communication
  { id: 'personalization', title: 'Personalization', subtitle: 'Caller types, categories, labels, grouping' },
  { id: 'vocabulary', title: 'Vocabulary', subtitle: 'Fields and lists - the words and values calls use' },   // v12.10.8 (#1160)
  { id: 'integrations', title: 'Integrations', subtitle: 'Connected apps and webhooks' },
];

const AREA_SECTIONS: Record<Exclude<SettingsArea, 'grid'>, string[]> = {
  organization: ['Identity', 'Additional locations', 'Hours & locale', 'Holiday dates'],   // v12.10.26 (#2141): Locations right after Identity; v12.10.28 (#2206) 'Additional locations'
  ai: ['Phone & Activation', 'Agent Details', 'Voicemail', 'Handoff'],   // v12.10.8 (#1190): Identity extraction removed
  call: ['Conversation flow', 'Recording', 'Keypad menus', 'Hold Behavior', 'Processing Behavior', 'Texts on calls'],   // v12.10.23 (#2012): the page's order
  reliability: ['Provider & Processing Reliability', 'Platform Connectivity', 'Failure message', 'External Systems'],   // v12.10.25 (#2115): Failure message was on the page but not in the menu
  workflow: [],
  knowledge: ['Retrieval', 'Documents', 'Quick Answers'],
  security: SECURITY_PAGES.map((p) => p.label),   // v12.10.9: Platform · Users · User groups - these load PAGES, not scroll
  communication: ['Email', 'SMS testing'],
  texting: ['Text messaging workflow', 'Automatic reply'],   // v12.10.26 (#T154)
  personalization: ['Caller types', 'Categories', 'Labels', 'Messages workspace', 'Repeat callers'],   // v12.10.18 (#1864): Messages workspace (Automatic status moved in), Repeat callers last
  vocabulary: ['Fields', 'Lists'],   // v12.10.8 (#1160, VOCABULARY-CLEANUP V4)
  integrations: ['Webhooks', 'Connected systems', 'Failure policy'],
};

// v12.2.36.0 (#112): search aliases so content terms surface the owning area even when the word isn't in
// the title/subtitle/section names (e.g. "API" -> Integrations/Platform/Reliability, "EHR" -> Integrations).
const AREA_KEYWORDS: Record<Exclude<SettingsArea, 'grid'>, string[]> = {
  organization: ['address', 'location', 'timezone', 'business hours', 'holiday', 'logo', 'practice name', 'country'],
  ai: ['phone number', 'voice', 'tts', 'language', 'greeting', 'prompt', 'agent name', 'activation', 'assistant'],
  call: ['recording', 'transcription', 'transcript', 'silence', 'timeout', 'hold', 'filler', 'dtmf', 'speech', 'processing'],
  reliability: ['retry', 'retries', 'timeout', 'fallback', 'api', 'provider', 'llm', 'connectivity', 'platform api', 'failure'],
  workflow: ['classify', 'classification', 'intent', 'keypad', 'routing', 'terminal', 'nodes', 'booking', 'caller type', 'pre-routing'],
  knowledge: ['kb', 'faq', 'documents', 'sources', 'retrieval', 'quick answers'],
  security: ['session', 'security', 'platform', 'admin', 'timeout', 'idle', 'sign out', 'sign-in', 'login', 'password', 'lockout', '2-step', 'two-step', 'mfa', '2fa', 'authenticator', 'backup codes', 'users', 'people', 'invite', 'user groups', 'groups', 'roles', 'permissions', 'access'],
  communication: ['smtp', 'email', 'sms', 'oauth', 'outbound', 'mail'],
  texting: ['text', 'texting', 'sms', 'text messages', 'auto reply', 'automatic reply', 'workflow over text'],   // v12.10.26 (#T154)
  personalization: ['caller types', 'categories', 'labels', 'tags', 'grouping', 'repeat callers', 'automatic status', 'auto complete'],   // v12.10.16 (T113)
  // v12.10.8 (#1160): Vocabulary and Lists moved here with their search words.
  vocabulary: ['vocabulary', 'fields', 'field', 'tokens', 'token', 'terminology', 'wording', 'rename', 'patient', 'subject', 'custom field', 'input cleanup', 'identity', 'identity extraction', 'member id',
    // v12.4.16 (#500): Lists. A tenant looking for this will search for what is IN the list, not for the word.
    'lists', 'list', 'providers', 'locations', 'visit types', 'reference data', 'import', 'csv', 'external id'],
  integrations: ['api', 'webhook', 'ehr', 'emr', 'fhir', 'hl7', 'sftp', 'oauth', 'connected systems', 'scheduling', 'athena', 'pmweb'],
};

// v12.4.16 (#519): a FIELD-level search index, searched alongside the area haystack above.
//
// Why: until now the only haystack was an area's title, subtitle, section names and AREA_KEYWORDS, so the search
// could only ever match words that were already printed on a card or listed as an area alias. Searching
// "slot normalization" returned "No settings match" while the setting it names was on screen, under the
// practice-manager label "Caller input cleanup". Renaming a field for the tenant is right, but it must not hide the
// field from the people who call it by its internal name - that name is what appears in the code, in the backlog and
// in support conversations, so BOTH spellings have to find it.
//
// Each entry carries the visible LABEL (what the operator sees, and what the highlight scrolls to - the alias itself
// never appears in the rendered card, so flashSearchHit is given the label to look for), the field's help text, and
// its known alternative names. `help` is a condensed copy of the field's own "What it does" line; when that help is
// reworded in the section file, reword it here too or the search goes stale.
type SettingsFieldEntry = {
  area: Exclude<SettingsArea, 'grid'>;
  label: string;
  help: string;
  aliases: string[];
};

// Call Handling is indexed field by field because that is where the renames are heaviest (#519 was reported here).
// Other areas still match at area granularity via AREA_SECTIONS/AREA_KEYWORDS; add entries here as they are renamed.
const SETTINGS_FIELD_INDEX: SettingsFieldEntry[] = [
  { area: 'call', label: 'Speech timeout', help: 'How long the AI waits in silence after a prompt before counting it as no input. Per-turn timer; resets every time the caller speaks.', aliases: ['speechTimeout', 'speech timeout', 'no input timeout', 'no-input', 'silence timeout'] },
  // v12.10.23 (#2029): Silent caller replaces Max silence retries / Silence final action on the screen; the old words still find it.
  { area: 'call', label: 'Silent caller', help: 'After this many silent turns in a row the call goes to End call, Leave a Message or Transfer to staff - one choice when nothing was given, one when something was.', aliases: ['silent caller', 'silence', 'silent turns', 'max silence retries', 'silence retries', 'silence final action', 'reprompt'] },
  { area: 'call', label: 'Keypad menus', help: 'The keys every keypad menu uses - repeat, main menu, speak with someone, reserved - and short menus.', aliases: ['keypad', 'keypad menu', 'menu keys', 'dtmf menu', 'press 0', 'short menus', 'repeat menu', 'main menu'] },   // v12.10.23 (#2012 #2028)
  { area: 'call', label: 'End-of-speech', help: 'How long the AI waits after the caller stops talking before it replies. Auto detects the end of speech; set a fixed value if callers spell names or numbers out loud.', aliases: ['speechEndTimeout', 'speech end timeout', 'end of speech', 'endpointing', 'eos'] },
  { area: 'call', label: 'Caller input cleanup', help: 'Tidies what the caller says before it is read back and stored - joins spelled-out letters, fixes name casing, and standardizes dates and phone numbers.', aliases: ['slotNormalization', 'slot normalization', 'normalization', 'normalisation', 'slot cleanup', 'input cleanup', 'spelled out letters', 'name casing'] },
  { area: 'call', label: 'Operator keyword detection', help: 'Listens for "I want a human"-style escape phrases at any point in the call.', aliases: ['operatorDetect', 'operator detect', 'escape phrase', 'escape phrases', 'human detection'] },
  { area: 'call', label: 'Operator keyword action', help: 'What the AI does when an operator keyword is detected.', aliases: ['operatorAction', 'operator action'] },
  { area: 'call', label: 'Operator keywords', help: 'Comma-separated keywords that trigger an immediate escape to the operator action.', aliases: ['operatorKeywords', 'operator keywords', 'escape keywords'] },
  { area: 'call', label: 'Voicemail details', help: 'Smart (AI) reads a voicemail into the message fields, marked from voicemail; Basic (keywords) reads only the request type.', aliases: ['voicemail', 'voicemail details', 'voicemail ai', 'smart', 'basic'] },   // v12.10.15 (#1666)
  { area: 'call', label: 'Very-low-confidence action', help: 'What to do when speech-recognition confidence on a caller utterance is below the workflow confidence floor.', aliases: ['lowConfAction', 'low confidence action', 'confidenceFloor', 'confidence floor', 'asr confidence'] },
  { area: 'call', label: 'Acceptance', help: 'When the AI will accept DTMF key-presses from the caller.', aliases: ['dtmfAccept', 'dtmf accept', 'dtmf acceptance', 'keypad', 'touch tone', 'touch-tone'] },
  { area: 'call', label: 'Announce timing', help: 'When, if ever, the AI tells the caller they can use the keypad instead of speaking.', aliases: ['dtmfAnnounce', 'dtmf announce', 'keypad announcement'] },
  { area: 'call', label: 'Fallback delay', help: 'How long the AI waits after no-speech before offering DTMF as a backup.', aliases: ['dtmfDelay', 'dtmf delay', 'dtmf fallback'] },
  { area: 'call', label: 'Behavior', help: 'What the caller hears while the assistant is processing a step, or while being connected or transferred to a human.', aliases: ['filler', 'filler phrases', 'processing behavior', 'hold behavior', 'thinking sound', 'hold music'] },
  { area: 'call', label: 'Start delay', help: 'How long to wait into a processing step or hold before the chosen behavior begins.', aliases: ['holdDelay', 'hold delay', 'procDelay', 'processing delay', 'start delay'] },
  { area: 'call', label: 'Keep call transcript', help: 'Master switch for keeping the text transcript of each call. Independent of audio recording.', aliases: ['transcriptEnabled', 'keep transcript', 'call transcript'] },
  { area: 'call', label: 'Transcript retention', help: 'How long text transcripts are kept before automatic deletion.', aliases: ['transcriptRetention', 'transcript retention', 'retention', 'purge'] },
  { area: 'call', label: 'Auto-redact PHI', help: 'Automatically masks protected health information - names, DOB, IDs - in stored transcripts. Transcript text only; audio is not redacted.', aliases: ['redactPhi', 'auto redact', 'phi', 'redaction', 'hipaa', 'masking'] },
  { area: 'call', label: 'Recording retention', help: 'How long call audio recordings are kept before automatic deletion.', aliases: ['recordingRetention', 'recording retention', 'audio retention', 'purge'] },
];

// v12.4.16 (#519): the lowercased query matches a field on its label, its help text OR any alternative name.
function matchSettingsFields(query: string): SettingsFieldEntry[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return SETTINGS_FIELD_INDEX.filter(
    (entry) => [entry.label, entry.help, ...entry.aliases].join(' ').toLowerCase().includes(q),
  );
}

// v12.4.16 (#519): an area matches when its own haystack matches OR one of its indexed fields does.
function areaMatchesQuery(area: { id: Exclude<SettingsArea, 'grid'>; title: string; subtitle: string }, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = [area.title, area.subtitle, ...(AREA_SECTIONS[area.id] ?? []), ...(AREA_KEYWORDS[area.id] ?? [])]
    .join(' ')
    .toLowerCase();
  if (haystack.includes(q)) return true;
  return matchSettingsFields(q).some((entry) => entry.area === area.id);
}

const AREA_TO_SLUG: Record<Exclude<SettingsArea, 'grid'>, string> = {
  organization: 'organization',
  ai: 'assistant',
  call: 'call-handling',
  reliability: 'reliability',
  workflow: 'workflow',
  knowledge: 'knowledge-base',
  security: 'security',
  communication: 'communication',
  texting: 'text-messaging',   // v12.10.26 (#T154)
  personalization: 'personalization',
  vocabulary: 'vocabulary',
  integrations: 'integrations',
};

const SLUG_TO_AREA: Record<string, SettingsArea> = {
  organization: 'organization',
  'ai-assistant': 'grid',
  assistant: 'ai',
  'call-handling': 'call',
  recording: 'grid',
  reliability: 'reliability',
  workflow: 'workflow',
  'knowledge-base': 'knowledge',
  platform: 'security',   // v12.10.9: old links land on Security
  security: 'security',
  account: 'grid',   // v12.10.9: /configuration/account opens Your account over the Settings grid
  communication: 'communication',
  'text-messaging': 'texting',   // v12.10.26 (#T154)
  personalization: 'personalization',
  vocabulary: 'vocabulary',
  integrations: 'integrations',
};

// AAR12: AI Agent sub-section keys, in the same order as AREA_SECTIONS.ai, so the nav red dots
// can be matched to the dirty map reported by AiAgentSections.
const AI_SECTION_KEYS: AiSectionKey[] = ['phone', 'details', 'voicemail', 'handoff'];   // v12.10.8 (#1190)
// Call Handling sub-section keys, same order as AREA_SECTIONS.call.
const CALL_SECTION_KEYS: CallSectionKey[] = ['conversation', 'recording', 'menus', 'hold', 'processing', 'texts'];   // v12.10.26 (#T154): + Texts on calls   // v12.10.23 (#2012)
// Reliability sub-section keys, same order as AREA_SECTIONS.reliability (External Systems is pointer-only, never dirty).
const RELIABILITY_SECTION_KEYS: (ReliabilitySectionKey | undefined)[] = ['provider', 'platform', undefined];
// Knowledge Base sub-section keys, same order as AREA_SECTIONS.knowledge (Documents applies immediately, never section-dirty).
const KB_SECTION_KEYS: (KbSectionKey | undefined)[] = ['retrieval', undefined, 'quickanswers'];
// Communication sub-section keys, same order as AREA_SECTIONS.communication (SMS testing is test-only, never dirty).
const COMM_SECTION_KEYS: (CommunicationSectionKey | undefined)[] = ['email', undefined];
// v12.10.26 (#T154): Text Messaging sub-section keys, same order as AREA_SECTIONS.texting.
const TEXTING_SECTION_KEYS: TextingSectionKey[] = ['workflow', 'autoReply'];
// Personalization sub-section keys, same order as AREA_SECTIONS.personalization.
const PERSONALIZATION_SECTION_KEYS: PzSectionKey[] = ['callerTypes', 'categories', 'labels', 'autoStatus', 'grouping'];   // v12.10.18 (#1864) order follows the page   // v12.10.17 (#1758): Automatic status has its own dot
// v12.10.8 (#1160): the Vocabulary area's sub-sections - the same component and dirty map as Personalization.
const VOCABULARY_SECTION_KEYS: PzSectionKey[] = ['vocabulary', 'lists'];
// Integrations sub-section keys, same order as AREA_SECTIONS.integrations (Connected systems is a
// card-grid whose CRUD applies immediately on drawer-save — never section-dirty).
const INTEGRATIONS_SECTION_KEYS: (IntSectionKey | undefined)[] = ['webhooks', undefined, 'failure'];

// v12.10.9 (#1253): which access key (GET /api/t2/security/me -> access, 's:<Area>:<Section>') each nav section needs,
// in the same order as AREA_SECTIONS. null = no key of its own (shown whenever the area is shown, e.g. the Reliability
// "External Systems" pointer). Personalization's four sections are one access row (Workspace). The names are the
// prototype's ROWS (T2_Settings_v1_85), which the catalog uses verbatim.
const SECTION_ACCESS: Partial<Record<Exclude<SettingsArea, 'grid' | 'security'>, (string | null)[]>> = {
  organization: ['s:Organization:Identity', 's:Organization:Locations', 's:Organization:Hours & locale', 's:Organization:Holiday dates'],   // v12.10.26 (#2141): its own rights row
  ai: ['s:AI Agent:Phone & activation', 's:AI Agent:Agent details', 's:AI Agent:Voicemail', 's:AI Agent:Handoff'],
  call: ['s:Call Handling:Conversation flow', 's:Call Handling:Recording', 's:Call Handling:Keypad menus', 's:Call Handling:Hold behavior', 's:Call Handling:Processing behavior', 's:Call Handling:Texts on calls'],   // v12.10.25 (#2115): Keypad menus has its own row   // v12.10.23 (#2012): Keypad menus rides on Conversation flow (no catalog row of its own yet)
  reliability: ['s:Reliability:Provider & processing', 's:Reliability:Platform connectivity', 's:Reliability:Failure message', 's:Reliability:External systems'],   // v12.10.25 (#2115)
  knowledge: ['s:Knowledge Base:Retrieval', 's:Knowledge Base:Documents', 's:Knowledge Base:Quick answers'],
  communication: ['s:Communication:Email (SMTP)', 's:Communication:SMS testing'],
  texting: ['s:Text Messaging:Text messaging workflow', 's:Text Messaging:Automatic reply'],   // v12.10.26 (#T154 Q17)
  personalization: ['s:Personalization:Caller types', 's:Personalization:Categories', 's:Personalization:Labels', 's:Personalization:Messages workspace', 's:Personalization:Repeat callers'],   // v12.10.25 (#2115): one row per section (was Workspace x5)   // v12.10.16 (T113): + Automatic status
  vocabulary: ['s:Vocabulary:Fields', 's:Vocabulary:Lists'],
  integrations: ['s:Integrations:Webhooks', 's:Integrations:Connected systems', 's:Integrations:Failure policy'],
};
// Area-level keys used when an area has no per-section list (Workflow) or as an extra way in (Reliability's failure message).
const AREA_EXTRA_ACCESS: Partial<Record<Exclude<SettingsArea, 'grid'>, string[]>> = {
  workflow: ['s:Workflow:Workflow'],
  reliability: ['s:Reliability:Failure message'],
};

// v12.10.25 (#2079): menu entry -> section card BY TITLE (the card's h2 starts like the menu label, or the other way round); a menu
// label with no titled card falls back to the card at the same position. Cards nested in another card never count.
function normTitle(t: string): string { return t.toLowerCase().replace(/[^a-z0-9&]+/g, ' ').trim(); }
function navCards(area: SettingsArea): (HTMLElement | undefined)[] {
  const all = (Array.from(document.querySelectorAll('.cfg-content .settings-section-card')) as HTMLElement[])
    .filter((c) => !c.parentElement?.closest('.settings-section-card'));
  const labels = (area === 'grid' ? [] : (AREA_SECTIONS as Record<string, string[]>)[area]) ?? [];
  const titleOf = (c: HTMLElement) => normTitle(c.querySelector('h2, h3')?.textContent ?? '');
  const used = new Set<HTMLElement>();
  const found = labels.map((label) => {
    const n = normTitle(label);
    const c = all.find((x) => !used.has(x) && n && (titleOf(x) === n || titleOf(x).startsWith(n) || (titleOf(x) && n.startsWith(titleOf(x)))));
    if (c) used.add(c);
    return c;
  });
  return found.map((c, i) => c ?? all.filter((x) => !used.has(x))[i - found.slice(0, i).filter(Boolean).length] ?? all[i]);
}

const AREA_COPY: Record<SettingsArea, { title: string; description: string }> = {
  grid: { title: 'Choose an area', description: 'Settings apply across every workflow and surface for this organization.' },
  organization: { title: 'Organization', description: 'Identity, business hours, and holiday closures for this organization.' },
  ai: { title: 'AI Agent', description: 'Your virtual receptionist — phone, voicemail, handoff, and the languages it speaks.' },
  call: { title: 'Call Handling', description: 'How the AI conducts a live call — conversation flow, processing & hold behavior, and recording.' },
  reliability: { title: 'Reliability', description: 'What happens when the machinery behind a call fails — retries, timeouts, and defined fallbacks.' },
  workflow: { title: 'Workflow', description: 'How your calls are answered and routed.' },
  knowledge: { title: 'Knowledge Base', description: 'Tenant-controlled answers for common caller questions.' },
  security: { title: 'Security', description: 'Sign-in rules and sessions, the people who can sign in, and what each user group can open.' },   // v12.10.9 (SecurityArea draws its own page head)
  communication: { title: 'Communication', description: 'How this organization sends outbound email (SMTP) and tests text-message delivery.' },
  texting: { title: 'Text Messaging', description: 'Patients who text the practice first - the Text messaging workflow and the automatic reply when it is off.' },   // v12.10.26 (#T154)
  personalization: { title: 'Personalization', description: 'Caller types, categories, labels, and how repeat callers’ messages are grouped in the agent workspace.' },
  vocabulary: { title: 'Vocabulary', description: 'The fields a call stores and the lists of values they can hold. Switch one Off to hide it from screens; calls still store it.' },   // v12.10.8.1 (#1229): shorter (Tushar 10/5)
  integrations: { title: 'Integrations', description: 'Connected apps, future APIs, and external webhooks.' },
};

const SECTION_DOM_ID: Record<OrgSection, string> = {
  identity: 'sec-identity',
  locations: 'sec-locations',   // v12.10.26 (#2141)
  hours: 'sec-hours-locale',
  holidays: 'sec-holiday-dates',
};

const ORG_SECTION_ORDER: OrgSection[] = ['identity', 'locations', 'hours', 'holidays'];   // v12.10.26 (#2141)

const INDUSTRIES = ['Healthcare', 'Legal', 'Manufacturing', 'Finance', 'Real Estate', 'Hospitality', 'Home Services', 'Other'];

const TIMEZONES = [
  { value: 'America/New_York', label: 'America/New_York (ET, UTC-5/-4)' },
  { value: 'America/Chicago', label: 'America/Chicago (CT)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PT)' },
];

const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const FALLBACK_SETTINGS: OrganizationSettings = {
  identity: { legalName: '', displayName: '', industry: 'Healthcare', timezoneId: 'America/New_York' },
  hours: [1, 2, 3, 4, 5, 6, 7].map((day) => ({
    dayOfWeek: day,
    isOpen: day <= 5,
    openTime: day <= 5 ? '09:00' : null,
    closeTime: day <= 5 ? '17:00' : null,
    breakEnabled: false,
    breakStartTime: null,
    breakEndTime: null,
  })),
  holidays: { years: [new Date().getFullYear(), new Date().getFullYear() + 1], items: [] },
};

function cloneSettings(value: OrganizationSettings): OrganizationSettings {
  return JSON.parse(JSON.stringify(value)) as OrganizationSettings;
}

function sameJson(a: unknown, b: unknown) {
  return JSON.stringify(a) === JSON.stringify(b);
}

function isoDate(year: number, month: number, day: number) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
function nthWeekday(year: number, month: number, weekday: number, n: number) {
  const first = new Date(year, month - 1, 1);
  const shift = (weekday - first.getDay() + 7) % 7;
  return isoDate(year, month, 1 + shift + (n - 1) * 7);
}
function lastWeekday(year: number, month: number, weekday: number) {
  const lastDay = new Date(year, month, 0).getDate();
  const lastDate = new Date(year, month - 1, lastDay);
  const shift = (lastDate.getDay() - weekday + 7) % 7;
  return isoDate(year, month, lastDay - shift);
}
function usFederalHolidays(year: number): { name: string; date: string; defaultOn: boolean }[] {
  return [
    // v12.10.11.1 (#1479): the six most medical offices close are pre-ticked (same six the server seeds)
    { name: "New Year's Day", date: isoDate(year, 1, 1), defaultOn: true },
    { name: 'MLK Day', date: nthWeekday(year, 1, 1, 3), defaultOn: false },
    { name: 'Presidents Day', date: nthWeekday(year, 2, 1, 3), defaultOn: false },
    { name: 'Memorial Day', date: lastWeekday(year, 5, 1), defaultOn: true },
    { name: 'Juneteenth', date: isoDate(year, 6, 19), defaultOn: false },
    { name: 'Independence Day', date: isoDate(year, 7, 4), defaultOn: true },
    { name: 'Labor Day', date: nthWeekday(year, 9, 1, 1), defaultOn: true },
    { name: 'Thanksgiving', date: nthWeekday(year, 11, 4, 4), defaultOn: true },
    { name: 'Christmas', date: isoDate(year, 12, 25), defaultOn: true },
  ];
}
function buildHolidayItems(years: number[], saved: HolidayItem[]): HolidayItem[] {
  const customs = saved.filter((i) => i.type === 'custom');
  const result: HolidayItem[] = [];
  for (const year of years) {
    for (const h of usFederalHolidays(year)) {
      const match = saved.find((i) => i.type !== 'custom' && i.year === year && i.name === h.name);
      result.push({ year, date: h.date, name: h.name, type: 'public', observed: match ? match.observed : h.defaultOn });
    }
  }
  return [...result, ...customs];
}

function normalizeSettings(value?: OrganizationSettings): OrganizationSettings {
  const merged = {
    ...FALLBACK_SETTINGS,
    ...(value ?? {}),
    identity: { ...FALLBACK_SETTINGS.identity, ...(value?.identity ?? {}) },
    hours: value?.hours?.length ? value.hours : FALLBACK_SETTINGS.hours,
    holidays: {
      ...FALLBACK_SETTINGS.holidays,
      ...(value?.holidays ?? {}),
      items: value?.holidays?.items ?? [],
    },
  };
  const years = merged.holidays.years?.length ? merged.holidays.years : FALLBACK_SETTINGS.holidays.years;
  merged.holidays.years = years;
  merged.holidays.items = buildHolidayItems(years, merged.holidays.items);
  return cloneSettings(merged);
}

function areaFromSection(section?: string): SettingsArea {
  if (!section) return 'grid';
  return SLUG_TO_AREA[section] ?? 'grid';
}

function areaPath(area: SettingsArea) {
  if (area === 'grid') return '/settings';
  return `/configuration/${AREA_TO_SLUG[area]}`;
}

/* ---------- inline icons ---------- */
type IconProps = { className?: string };
function Icon({ d, className }: { d: ReactNode; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      {d}
    </svg>
  );
}
const SearchIcon = (p: IconProps) => <Icon className={p.className} d={<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>} />;
const GlobeIcon = (p: IconProps) => <Icon className={p.className} d={<><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" /></>} />;
const MailIcon = (p: IconProps) => <Icon className={p.className} d={<><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 7L2 7" /></>} />;
const PhoneIcon = (p: IconProps) => <Icon className={p.className} d={<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z" />} />;
const CoffeeIcon = (p: IconProps) => <Icon className={p.className} d={<><path d="M18 8h1a4 4 0 0 1 0 8h-1" /><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" /><path d="M6 2v3M10 2v3M14 2v3" /></>} />;
const CheckIcon = (p: IconProps) => <Icon className={p.className} d={<path d="M20 6L9 17l-5-5" />} />;
const EditIcon = (p: IconProps) => <Icon className={p.className} d={<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />} />;
const XIcon = (p: IconProps) => <Icon className={p.className} d={<path d="M18 6L6 18M6 6l12 12" />} />;
const PlusIcon = (p: IconProps) => <Icon className={p.className} d={<path d="M12 5v14M5 12h14" />} />;
const ImageIcon = (p: IconProps) => <Icon className={p.className} d={<><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></>} />;
const UploadIcon = (p: IconProps) => <Icon className={p.className} d={<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M17 8l-5-5-5 5" /><path d="M12 3v12" /></>} />;
const CopyIcon = (p: IconProps) => <Icon className={p.className} d={<><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></>} />;
const ChevR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6" /></svg>;

const AreaOrganization = () => <Icon d={<><path d="M3 21h18" /><path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" /><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01" /></>} />;
const SettingsGear = () => <Icon d={<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8 2 2 0 1 1-2.8 2.8 1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5 2 2 0 1 1-4 0 1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3 2 2 0 1 1-2.8-2.8 1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1 2 2 0 1 1 0-4 1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8 2 2 0 1 1 2.8-2.8 1.6 1.6 0 0 0 1.8.3 1.6 1.6 0 0 0 1-1.5 2 2 0 1 1 4 0 1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3 2 2 0 1 1 2.8 2.8 1.6 1.6 0 0 0-.3 1.8 1.6 1.6 0 0 0 1.5 1 2 2 0 1 1 0 4 1.6 1.6 0 0 0-1.5 1z" /></>} />;
const AreaAi = () => <Icon d={<><rect x="4" y="8" width="16" height="12" rx="2" /><path d="M12 8V4M9 2h6M8 13h.01M16 13h.01M9 17h6" /></>} />;
const AreaCall = () => <Icon d={<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z" />} />;
const AreaReliability = () => <Icon d={<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></>} />;
const AreaWorkflow = () => <Icon d={<><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /><path d="M10 6.5h4a2 2 0 0 1 2 2V14" /></>} />;
const AreaKnowledge = () => <Icon d={<path d="M4 19V5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2zM18 21H6" />} />;
const AreaSecurity = () => <Icon d={<><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>} />;   // v12.10.9: lock
const AreaCommunication = () => <Icon d={<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.8-.8L3 21l1.9-5a8.4 8.4 0 0 1-.8-3.6 8.5 8.5 0 1 1 16.9.1z" />} />;
const AreaTexting = () => <Icon d={<><rect x="3" y="5" width="18" height="13" rx="3" /><path d="M7 10h10M7 13.5h6M8 18l-2 3" /></>} />;   // v12.10.26 (#T154)
const AreaPersonalization = () => <Icon d={<><circle cx="12" cy="8" r="4" /><path d="M5 21a7 7 0 0 1 14 0" /></>} />;
const AreaVocabulary = () => <Icon d={<><path d="M4 4h12a4 4 0 0 1 4 4v12H8a4 4 0 0 1-4-4z" /><path d="M8 9h8M8 13h5" /></>} />;   // v12.10.8 (#1160)
const AreaIntegrations = () => <Icon d={<path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />} />;
const AREA_ICONS: Record<Exclude<SettingsArea, 'grid'>, ReactNode> = {
  organization: <AreaOrganization />,
  ai: <AreaAi />,
  call: <AreaCall />,
  reliability: <AreaReliability />,
  workflow: <AreaWorkflow />,
  knowledge: <AreaKnowledge />,
  security: <AreaSecurity />,
  communication: <AreaCommunication />,
  texting: <AreaTexting />,   // v12.10.26 (#T154)
  personalization: <AreaPersonalization />,
  vocabulary: <AreaVocabulary />,
  integrations: <AreaIntegrations />,
};

function validateValue(kind: 'url' | 'email' | 'phone', value: string): boolean {
  const v = value.trim();
  if (kind === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  if (kind === 'url') return /^https?:\/\/.+\..+/.test(v);
  return v.replace(/\D/g, '').length >= 10;
}
function formatPhone(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length <= 3) return local.length > 0 ? `(${local}` : '';
  if (local.length <= 6) return `(${local.slice(0, 3)}) ${local.slice(3)}`;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
}
function fmt12(t?: string | null) {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  const ap = h < 12 ? 'AM' : 'PM';
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, '0')} ${ap}`;
}
function formatHolidayDate(value: string) {
  if (!value) return 'No date';
  const parsed = new Date(`${value}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
function isImageSrc(value?: string | null): value is string {
  if (!value) return false;
  return value.startsWith('data:') || value.startsWith('http') || value.startsWith('/');
}

export default function SettingsPage() {
  const { claims } = useAuth();
  const { section } = useParams();
  const navigate = useNavigate();
  const navGuard = useNavGuard();
  const queryClient = useQueryClient();
  const activeArea = areaFromSection(section);
  // v12.10.9 (#1253): what this person may open - areas and sections without access are hidden; the server enforces anyway.
  const { canOpen, hasAccess } = useAccess();
  const sectionCanEdit = (k: string) => hasAccess(k, 'edit');   // v12.10.26 (#2141): Locations drawer is read-only without Edit
  const securityPages = useSecurityPages();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState<OrgSection>('identity');
  const [activeSubIndex, setActiveSubIndex] = useState(0);   // v12.2.40.0 (#229): active section for non-org areas
  const [saved, setSaved] = useState<OrganizationSettings>(FALLBACK_SETTINGS);
  const [draft, setDraft] = useState<OrganizationSettings>(FALLBACK_SETTINGS);
  const [pendingArea, setPendingArea] = useState<SettingsArea | null>(null);
  // v12.4.0 (#390): Discard draft threw an entire editing session away on ONE click, with no guard at all.
  // The M4 unsaved guard already existed for navigating away dirty - which is the SAME loss with more
  // steps, so the deliberate button had less protection than the accidental route. It routes through the
  // same dialog now: one component, seven variants (SPEC_modals_v1_3 section 8.1), not a second one here.
  const [confirmDiscard, setConfirmDiscard] = useState(false);
  const [pendingPath, setPendingPath] = useState<string | null>(null);
  const [saveMessage, setSaveMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [holidayYear, setHolidayYear] = useState<number>(new Date().getFullYear());
  const [logoPreview, setLogoPreview] = useState<{ icon?: string; full?: string }>({});
  const [toastMessage, setToastMessage] = useState('');
  // GG1 (v12.1.30.0): live search query for the "Choose an area" grid landing.
  const [gridQuery, setGridQuery] = useState('');
  const searchRef = useRef<HTMLInputElement>(null);
  const toastTimer = useRef<number | undefined>(undefined);
  const suppressSpy = useRef(false);

  const { data, isLoading, error } = useQuery<OrganizationSettings>({
    queryKey: ['t2-organization-settings'],
    queryFn: () => api.get<OrganizationSettings>('/t2/settings/organization'),
  });

  // v12.10.26 (#2141): Organization › Locations - Hours & locale shows one pill per location (2+), the main one selected; the
  // main pill edits the practice week (draft.hours, the Hours check); every other pill edits that location's own week.
  const locationsQuery = useLocations(activeArea === 'organization');
  const orgLocations = locationsQuery.data?.locations ?? [];
  const [hoursLocId, setHoursLocId] = useState<number | null>(null);
  const [locHoursDraft, setLocHoursDraft] = useState<Record<number, LocationHour[]>>({});
  const locHoursSaved = useMemo(() => {
    const m: Record<number, LocationHour[]> = {};
    orgLocations.filter((l) => !l.isMain).forEach((l) => { m[l.id] = [...(l.hours ?? [])].sort((a, b) => a.dayOfWeek - b.dayOfWeek); });
    return m;
  }, [orgLocations]);
  const dirtyLocHourIds = Object.keys(locHoursDraft).map(Number).filter((id) => locHoursSaved[id] && !sameJson(locHoursDraft[id], locHoursSaved[id]));
  const hoursLoc = orgLocations.length > 1 ? orgLocations.find((l) => l.id === hoursLocId && !l.isMain) ?? null : null;   // null = the main location

  // v12.10.11 (#1440): the latest saved / draft, read by the merge below without stale closures.
  const savedRef = useRef(saved);
  const draftRef = useRef(draft);
  savedRef.current = saved;
  draftRef.current = draft;

  // v12.10.11 (#1440): a server copy (first load, a refetch, or a section's save echo) replaces only the sections
  // the user is NOT editing. Tushar on UAT1 10/8: "when i edited several sections, and then just clicked on Hours &
  // locale and it saved but then i lost the changes done to other boxes." Every save used to reset the whole draft.
  function applyServerCopy(server: OrganizationSettings, justSaved?: OrgSection) {
    const prevSaved = savedRef.current;
    const prevDraft = draftRef.current;
    const loaded = prevSaved !== FALLBACK_SETTINGS;
    const next = cloneSettings(server);
    (['identity', 'hours', 'holidays'] as const).forEach((key) => {   // v12.10.26 (#2141): the draft's own sections (Locations is not a draft)
      if (key === justSaved || !loaded) return;
      if (!sameJson(prevDraft[key], prevSaved[key])) (next as unknown as Record<OrgSection, unknown>)[key] = prevDraft[key];
    });
    savedRef.current = server;
    draftRef.current = next;
    setSaved(server);
    setDraft(next);
  }

  useEffect(() => {
    if (!data) return;
    const normalized = normalizeSettings(data);
    applyServerCopy(normalized);
    setHolidayYear(normalized.holidays.years[0] ?? new Date().getFullYear());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const isIdentityDirty = !sameJson(draft.identity, saved.identity);
  const isMainHoursDirty = !sameJson(draft.hours, saved.hours);
  const isHoursDirty = isMainHoursDirty || dirtyLocHourIds.length > 0;   // v12.10.26 (#2141): any location's week
  const isHolidaysDirty = !sameJson(draft.holidays, saved.holidays);
  const isDirty = isIdentityDirty || isHoursDirty || isHolidaysDirty;
  const copy = AREA_COPY[activeArea];

  // AAR12: AI Agent reports its per-section dirty state + save/discard-all up here, so the shell's
  // area/section red dots and the "Save all changes" / "Discard draft" buttons reflect AI edits.
  const [aiState, setAiState] = useState<AiAgentState | null>(null);
  const handleAiState = useCallback((s: AiAgentState) => setAiState(s), []);
  useEffect(() => { setActiveSubIndex(0); }, [activeArea]);   // v12.2.40.0 (#229): first section active on area switch
  useEffect(() => { if (activeArea !== 'ai') setAiState(null); }, [activeArea]);
  const aiActive = activeArea === 'ai';
  const aiAnyDirty = aiActive && !!aiState?.anyDirty;

  // Call Handling reports its per-section dirty state + save/discard-all the same way.
  const [callState, setCallState] = useState<CallHandlingState | null>(null);
  const handleCallState = useCallback((s: CallHandlingState) => setCallState(s), []);
  useEffect(() => { if (activeArea !== 'call') setCallState(null); }, [activeArea]);
  const callActive = activeArea === 'call';
  const callAnyDirty = callActive && !!callState?.anyDirty;

  // Reliability reports its per-section dirty state + save/discard-all the same way.
  const [relState, setRelState] = useState<ReliabilityState | null>(null);
  const handleRelState = useCallback((s: ReliabilityState) => setRelState(s), []);
  useEffect(() => { if (activeArea !== 'reliability') setRelState(null); }, [activeArea]);
  const relActive = activeArea === 'reliability';
  const relAnyDirty = relActive && !!relState?.anyDirty;

  // Knowledge Base reports its per-section dirty state the same way.
  const [kbState, setKbState] = useState<KnowledgeBaseState | null>(null);
  const handleKbState = useCallback((s: KnowledgeBaseState) => setKbState(s), []);
  useEffect(() => { if (activeArea !== 'knowledge') setKbState(null); }, [activeArea]);
  const kbActive = activeArea === 'knowledge';
  const kbAnyDirty = kbActive && !!kbState?.anyDirty;

  // v12.10.9: Security (replaces Platform) reports its unsaved Platform / User-groups drafts the same way. Its sub-pages
  // are PAGES (?page=users|groups), not scroll targets.
  const [secState, setSecState] = useState<SecurityState | null>(null);
  const handleSecState = useCallback((s: SecurityState) => setSecState(s), []);
  useEffect(() => { if (activeArea !== 'security') setSecState(null); }, [activeArea]);
  const secActive = activeArea === 'security';
  const secAnyDirty = secActive && !!secState?.anyDirty;
  const secPageParam = searchParams.get('page');
  const securityPage: SecurityPageKey = secPageParam === 'users' || secPageParam === 'groups' ? secPageParam : 'platform';
  // v12.10.9.3 (#1328): Security with no ?page= shows its three tiles; a tile (or the left menu) opens ?page=platform|users|groups.
  const securityHub = secActive && !secPageParam;
  const setSecurityPage = useCallback((p: SecurityPageKey) => {
    setSearchParams((cur) => {
      const next = new URLSearchParams(cur);
      next.set('page', p);
      return next;
    });
  }, [setSearchParams]);
  const showSecurityTiles = useCallback(() => {
    setSearchParams((cur) => { const next = new URLSearchParams(cur); next.delete('page'); return next; });
  }, [setSearchParams]);

  // v12.10.9 (#1253): area / section visibility from the person's access (unknown -> visible).
  const areaVisible = (area: SettingsArea): boolean => {
    if (area === 'grid') return true;
    if (area === 'security') return securityPages.length > 0;
    const keys = [...(SECTION_ACCESS[area] ?? []).filter((k): k is string => !!k), ...(AREA_EXTRA_ACCESS[area] ?? [])];
    return !keys.length || keys.some((k) => canOpen(k));
  };
  const sectionVisible = (area: SettingsArea, index: number): boolean => {
    if (area === 'grid') return true;
    if (area === 'security') return securityPages.some((p) => p.label === AREA_SECTIONS.security[index]);
    const k = SECTION_ACCESS[area]?.[index];
    return k ? canOpen(k) : areaVisible(area);
  };
  const visibleAreas = SETTINGS_AREAS.filter((area) => areaVisible(area.id));

  // Communication reports its per-section dirty state the same way.
  const [commState, setCommState] = useState<CommunicationState | null>(null);
  const handleCommState = useCallback((s: CommunicationState) => setCommState(s), []);
  useEffect(() => { if (activeArea !== 'communication') setCommState(null); }, [activeArea]);
  const commActive = activeArea === 'communication';
  const commAnyDirty = commActive && !!commState?.anyDirty;

  // v12.10.26 (#T154): Text Messaging reports its per-section dirty state the same way.
  const [txState, setTxState] = useState<TextMessagingState | null>(null);
  const handleTxState = useCallback((s: TextMessagingState) => setTxState(s), []);
  useEffect(() => { if (activeArea !== 'texting') setTxState(null); }, [activeArea]);
  const txActive = activeArea === 'texting';
  const txAnyDirty = txActive && !!txState?.anyDirty;

  // Personalization reports its per-section dirty state the same way.
  const [pzState, setPzState] = useState<PersonalizationState | null>(null);
  const handlePzState = useCallback((s: PersonalizationState) => setPzState(s), []);
  // v12.10.8 (#1160): the Vocabulary area is the same component - it reports through the same state.
  useEffect(() => { if (activeArea !== 'personalization' && activeArea !== 'vocabulary') setPzState(null); }, [activeArea]);
  const pzActive = activeArea === 'personalization' || activeArea === 'vocabulary';
  const pzAnyDirty = pzActive && !!pzState?.anyDirty;

  // Integrations reports its per-section dirty state the same way.
  const [intState, setIntState] = useState<IntegrationsState | null>(null);
  const handleIntState = useCallback((s: IntegrationsState) => setIntState(s), []);
  useEffect(() => { if (activeArea !== 'integrations') setIntState(null); }, [activeArea]);
  const intActive = activeArea === 'integrations';
  const intAnyDirty = intActive && !!intState?.anyDirty;

  // v12.2.36.0 (#192): Workflow reports dirty + save/discard up the same way, so it uses the shared hero.
  const [workflowState, setWorkflowState] = useState<WorkflowSnapshotState | null>(null);
  const handleWorkflowState = useCallback((st: WorkflowSnapshotState) => setWorkflowState(st), []);
  useEffect(() => { if (activeArea !== 'workflow') setWorkflowState(null); }, [activeArea]);
  const workflowActive = activeArea === 'workflow';
  const workflowAnyDirty = workflowActive && !!workflowState?.anyDirty;

  const heroDirty = workflowActive ? workflowAnyDirty : aiActive ? aiAnyDirty : callActive ? callAnyDirty : relActive ? relAnyDirty : kbActive ? kbAnyDirty : secActive ? secAnyDirty : commActive ? commAnyDirty : txActive ? txAnyDirty : pzActive ? pzAnyDirty : intActive ? intAnyDirty : isDirty;
  const heroSave = workflowActive ? () => workflowState?.saveAll() : aiActive ? () => aiState?.saveAll() : callActive ? () => callState?.saveAll() : relActive ? () => relState?.saveAll() : kbActive ? () => kbState?.saveAll() : secActive ? () => secState?.saveAll() : commActive ? () => commState?.saveAll() : txActive ? () => txState?.saveAll() : pzActive ? () => pzState?.saveAll() : intActive ? () => intState?.saveAll() : saveAll;
  const heroDiscard = workflowActive ? () => workflowState?.discardAll() : aiActive ? () => aiState?.discardAll() : callActive ? () => callState?.discardAll() : relActive ? () => relState?.discardAll() : kbActive ? () => kbState?.discardAll() : secActive ? () => secState?.discardAll() : commActive ? () => commState?.discardAll() : txActive ? () => txState?.discardAll() : pzActive ? () => pzState?.discardAll() : intActive ? () => intState?.discardAll() : discardAll;

  // Guard ONLY navigation that LEAVES the Settings area. Moving between sections/areas inside
  // Settings (paths under /settings or /configuration) never prompts - the draft persists and is
  // committed via "Save all changes". Re-registers when isDirty changes so the closure is fresh.
  useEffect(() => {
    navGuard.register((path: string) => {
      const stayingInSettings = path.startsWith('/settings') || path.startsWith('/configuration');
      // v12.3.12 (#322): heroDirty, not isDirty. isDirty only knows about the Organization draft, so leaving
      // Settings with unsaved WORKFLOW (or Knowledge Base, or any other section's) work walked straight out.
      if (!heroDirty || stayingInSettings) return false;
      setPendingPath(path);
      return true;
    });
    return () => navGuard.register(null);
  }, [navGuard, isDirty, heroDirty]);   // v12.10.9: heroDirty too, so a Security draft is guarded with a fresh closure

  useEffect(() => {
    function handleBeforeUnload(event: BeforeUnloadEvent) {
      if (!heroDirty) return;   // v12.10.9.4 (#1335): any area's unsaved work, not only Organization
      event.preventDefault();
      event.returnValue = '';
    }
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [heroDirty]);

  useEffect(() => {
    function handleKey(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        searchRef.current?.focus();
      }
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => () => window.clearTimeout(toastTimer.current), []);

  useEffect(() => {
    if (activeArea === 'grid') return;   // v12.2.42.0 (#229): spy runs for EVERY area, not just organization
    const el = document.querySelector('.tenant-main') as HTMLElement | null;
    if (!el) return;
    el.scrollTo({ top: 0 });
    function handleScroll() {
      if (suppressSpy.current || !el) return;
      const threshold = el.getBoundingClientRect().top + el.clientHeight * 0.33;
      if (activeArea === 'organization') {
        let next: OrgSection = 'identity';
        ORG_SECTION_ORDER.forEach((orgSection) => {
          const sec = document.getElementById(SECTION_DOM_ID[orgSection]);
          if (sec && sec.getBoundingClientRect().top <= threshold) next = orgSection;
        });
        setActiveSection(next);
      } else {
        // v12.2.42.0 (#229): area-agnostic — highlight the Nth .settings-section-card at the threshold so
        // the left-nav sub-item tracks the scroll in AI Agent / Call Handling / Personalization / etc.
        const cards = navCards(activeArea);   // v12.10.25 (#2079): menu entry N = the card titled like it
        let idx = 0;
        cards.forEach((c, i) => { if (c && c.style.display !== 'none' && c.getBoundingClientRect().top <= threshold) idx = i; });
        setActiveSubIndex(idx);
      }
    }
    el.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => el.removeEventListener('scroll', handleScroll);
  }, [activeArea, isLoading]);

  // v12.10.9 (#1253): hide the section cards this person has no access to. The cards belong to each area's own component,
  // so they are matched by position - the same index mapping the left nav already uses (scrollToSectionIndex).
  const hiddenSectionKey = activeArea === 'grid' || activeArea === 'security' || activeArea === 'workflow'
    ? ''
    : (AREA_SECTIONS[activeArea] ?? []).map((_, i) => (sectionVisible(activeArea, i) ? '' : String(i))).filter(Boolean).join(',');
  useEffect(() => {
    if (!hiddenSectionKey) return;
    const hidden = hiddenSectionKey.split(',').map(Number);
    const root = document.querySelector('.cfg-content');
    if (!root) return;
    const apply = () => {
      const byNav = navCards(activeArea);   // v12.10.25 (#2079): the card for menu entry N, by title
      root.querySelectorAll<HTMLElement>('.settings-section-card').forEach((card) => {
        const i = byNav.indexOf(card);
        const hide = i >= 0 && hidden.includes(i);
        if (hide && card.style.display !== 'none') { card.style.display = 'none'; card.setAttribute('data-no-access', ''); }
        if (!hide && card.hasAttribute('data-no-access')) { card.style.display = ''; card.removeAttribute('data-no-access'); }
      });
    };
    apply();
    const mo = new MutationObserver(apply);
    mo.observe(root, { childList: true, subtree: true });
    return () => {
      mo.disconnect();
      root.querySelectorAll<HTMLElement>('.settings-section-card[data-no-access]').forEach((card) => { card.style.display = ''; card.removeAttribute('data-no-access'); });
    };
  }, [hiddenSectionKey, activeArea]);

  function showToast(message: string) {
    setToastMessage(message);
    window.clearTimeout(toastTimer.current);
    toastTimer.current = window.setTimeout(() => setToastMessage(''), 2600);
  }

  function scrollToSection(orgSection: OrgSection) {
    setActiveSection(orgSection);
    suppressSpy.current = true;
    document.getElementById(SECTION_DOM_ID[orgSection])?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => { suppressSpy.current = false; }, 600);
  }

  // v12.2.40.0 (#229): ONE area-agnostic section jump used by every non-Organization area. The nav sub-items are in
  // the same order as the rendered .settings-section-card set, so index N -> the Nth card. No per-page wiring.
  function scrollToSectionIndex(i: number) {
    setActiveSubIndex(i);
    // v12.10.25 (#2079): the card is found by its TITLE (Keypad menus landed on Recording when the cards and the menu were matched
    // only by position); the spy waits until the smooth scroll is over so it cannot pull the highlight back to the card above.
    const card = activeArea === 'grid' || activeArea === 'security' ? (document.querySelectorAll('.cfg-content .settings-section-card')[i] as HTMLElement | undefined) : navCards(activeArea)[i];
    if (!card) return;
    suppressSpy.current = true;
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => { suppressSpy.current = false; setActiveSubIndex(i); }, 900);
  }

  // v12.2.42.0 (#228): after a search hit opens an area, scroll to AND briefly flash the FIRST section card
  // whose text contains the query term — so "API" lands on the section that mentions API, not just the area
  // top. Content can mount async (org data query), so poll a few frames until the cards exist.
  function flashSearchHit(q: string) {
    if (!q) return;
    let tries = 0;
    const tick = () => {
      const cards = Array.from(document.querySelectorAll('.cfg-content .settings-section-card')) as HTMLElement[];
      if (!cards.length) { if (tries++ < 25) window.setTimeout(tick, 80); return; }
      let target = cards.findIndex((c) => (c.textContent ?? '').toLowerCase().includes(q));
      // v12.4.16 (#519): a query that matched on an ALIAS or on help text (e.g. "slot normalization") does not appear
      // in the rendered card at all, so the plain text scan above finds nothing and we used to land on card 0. Retry
      // with the visible labels of the fields that query matched - those ARE printed on the card that owns them.
      if (target < 0) {
        const labels = matchSettingsFields(q).map((entry) => entry.label.toLowerCase());
        target = cards.findIndex((c) => {
          const text = (c.textContent ?? '').toLowerCase();
          return labels.some((label) => text.includes(label));
        });
      }
      if (target < 0) target = 0;
      const el = cards[target];
      suppressSpy.current = true;
      setActiveSubIndex(target);
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // v12.2.43.0 (#228): PERSISTENT highlight — stays on the matched section until the next search hit or
      // area change (a transient flash faded too fast / felt like it vanished on mouse move).
      cards.forEach((c) => c.classList.remove('settings-section-hit'));
      el.classList.add('settings-section-hit');
      window.setTimeout(() => { suppressSpy.current = false; }, 800);
    };
    tick();
  }

  const saveIdentity = useMutation({
    mutationFn: (payload: OrganizationIdentity) => api.put<OrganizationSettings>('/t2/settings/organization/identity', payload),
    onSuccess: (result) => { handleSaved(result, 'Identity saved.', 'identity'); toast('success', 'Identity saved'); queryClient.invalidateQueries({ queryKey: LOCATIONS_KEY }); },   // v12.10.26 (#2141): the main location shows the same address / phone
    onError: handleApiError,
  });
  const saveHours = useMutation({
    mutationFn: (payload: BusinessHour[]) => api.put<OrganizationSettings>('/t2/settings/organization/hours', payload),
    onSuccess: (result) => { handleSaved(result, 'Business hours saved.', 'hours'); toast('success', 'Business hours saved'); },
    onError: handleApiError,
  });
  // v12.10.26 (#2141): the weeks of the non-main locations (one PUT each), then the list again (their Quick Answers changed too).
  const saveLocHours = useMutation({
    mutationFn: async (ids: number[]) => { for (const id of ids) await api.put(`/t2/settings/organization/locations/${id}/hours`, locHoursDraft[id]); },
    onSuccess: () => {
      setLocHoursDraft({});
      queryClient.invalidateQueries({ queryKey: LOCATIONS_KEY });
      queryClient.invalidateQueries({ queryKey: ['t2-knowledge-base'] });
      toast('success', 'Location hours saved');
    },
    onError: handleApiError,
  });
  const saveHolidays = useMutation({
    mutationFn: (payload: HolidayPayload) => api.put<OrganizationSettings>('/t2/settings/organization/holidays', payload),
    onSuccess: (result) => { handleSaved(result, 'Holidays saved.', 'holidays'); toast('success', 'Holidays saved'); },
    onError: handleApiError,
  });

  const saving = saveIdentity.isPending || saveHours.isPending || saveHolidays.isPending || saveLocHours.isPending;   // v12.10.26 (#2141)
  const currentArea = SETTINGS_AREAS.find((area) => area.id === activeArea);
  const needsOrganizationData = activeArea === 'organization';
  const holidaysForYear = useMemo(
    () => draft.holidays.items
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => item.year === holidayYear)
      .sort((a, b) => a.item.date.localeCompare(b.item.date)),
    [draft.holidays.items, holidayYear],
  );

  function goToArea(area: SettingsArea) {
    navigate(areaPath(area));
  }

  function handleSaved(result: OrganizationSettings, message: string, section: OrgSection) {
    const normalized = normalizeSettings(result);
    applyServerCopy(normalized, section);   // v12.10.11 (#1440): the other sections keep their unsaved edits
    setSaveMessage(message);
    setErrorMessage('');
    queryClient.setQueryData(['t2-organization-settings'], normalized);
    if (pendingArea) {
      goToArea(pendingArea);
      setPendingArea(null);
    }
    if (pendingPath) {
      const target = pendingPath;
      setPendingPath(null);
      navigate(target);
    }
    window.setTimeout(() => setSaveMessage(''), 3000);
  }

  function handleApiError(error: unknown) {
    const maybe = error as { message?: string; response?: { data?: { error?: string } } };
    setErrorMessage(maybe.response?.data?.error ?? maybe.message ?? 'Settings could not be saved.');
  }

  function changeArea(area: SettingsArea) {
    if (area === activeArea) return;
    // v12.3.12 (#322): this used to navigate unconditionally, on the reasoning that "the draft persists (same
    // route component)". That holds for the Organization draft, which lives in THIS component - it does not hold
    // for a section that is conditionally rendered and unmounts with its draft inside it. Workflow is exactly
    // that, which is how Tushar lost a node he had just built: "i went to knowledgebase to check something and
    // when i come back all the card and configuration was gone... the highlighted save all changes button turn
    // to disabled mode". Any section with unsaved work now gets asked before it is thrown away.
    if (heroDirty) { setPendingArea(area); return; }
    goToArea(area);
  }

  // v12.3.12 (#322): finish a guarded area change once the section is clean again - the user either saved
  // (the mutation settled and the draft cleared) or discarded. Sections own their own drafts and settle
  // asynchronously, so completion is observed rather than assumed.
  useEffect(() => {
    if (!pendingArea || heroDirty || saving) return;
    const target = pendingArea;
    setPendingArea(null);
    goToArea(target);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingArea, heroDirty, saving]);

  function discardAll() {
    setDraft(cloneSettings(saved));
    setLocHoursDraft({});   // v12.10.26 (#2141)
    setLogoPreview({});
    setErrorMessage('');
    if (pendingArea) {
      goToArea(pendingArea);
      setPendingArea(null);
    }
    if (pendingPath) {
      const target = pendingPath;
      setPendingPath(null);
      navigate(target);
    }
  }

  function saveAll() {
    setErrorMessage('');
    if (isIdentityDirty) saveIdentity.mutate(draft.identity);
    if (isMainHoursDirty) saveHours.mutate(draft.hours);
    if (dirtyLocHourIds.length > 0) saveLocHours.mutate(dirtyLocHourIds);   // v12.10.26 (#2141)
    if (isHolidaysDirty) saveHolidays.mutate(draft.holidays);
  }

  function updateIdentity<K extends keyof OrganizationIdentity>(key: K, value: OrganizationIdentity[K]) {
    setDraft((current) => ({ ...current, identity: { ...current.identity, [key]: value } }));
  }

  function updateHour(dayOfWeek: number, patch: Partial<BusinessHour>) {
    setDraft((current) => ({
      ...current,
      hours: current.hours.map((hour) => {
        if (hour.dayOfWeek !== dayOfWeek) return hour;
        const merged = { ...hour, ...patch };
        // v12.2.20.0 (#142): opening a previously-closed day must SEED real open/close times. The time
        // <input>s only DISPLAY a "09:00"/"17:00" fallback when the value is null — they don't commit it —
        // so an untouched field stayed null in state and the API rejected the save (400: "Open days need
        // valid open and close times"). Seed defaults here whenever a day becomes open with missing times.
        if (merged.isOpen) {
          if (!merged.openTime) merged.openTime = '09:00';
          if (!merged.closeTime) merged.closeTime = '17:00';
        }
        return merged;
      }),
    }));
  }

  // v12.10.26 (#2141): the same edit as updateHour, on a non-main location's week (opening a day seeds 9-5, #142).
  function updateLocHour(locId: number, dayOfWeek: number, patch: Partial<BusinessHour>) {
    setLocHoursDraft((current) => {
      const base = current[locId] ?? locHoursSaved[locId] ?? [];
      const next = base.map((hour) => {
        if (hour.dayOfWeek !== dayOfWeek) return hour;
        const merged = { ...hour, ...patch };
        if (merged.isOpen) { if (!merged.openTime) merged.openTime = '09:00'; if (!merged.closeTime) merged.closeTime = '17:00'; }
        return merged;
      });
      return { ...current, [locId]: next };
    });
  }

  function updateHoliday(index: number, patch: Partial<HolidayItem>) {
    setDraft((current) => ({
      ...current,
      holidays: { ...current.holidays, items: current.holidays.items.map((item, itemIndex) => (itemIndex === index ? { ...item, ...patch } : item)) },
    }));
  }

  function addHoliday(name: string, date: string) {
    setDraft((current) => ({
      ...current,
      holidays: { ...current.holidays, items: [...current.holidays.items, { year: holidayYear, date, name, type: 'custom', observed: true }] },
    }));
  }

  function removeHoliday(index: number) {
    setDraft((current) => ({ ...current, holidays: { ...current.holidays, items: current.holidays.items.filter((_, itemIndex) => itemIndex !== index) } }));
  }

  async function selectLogo(event: ChangeEvent<HTMLInputElement>, key: 'logoIconPath' | 'logoFullPath') {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    const slot = key === 'logoIconPath' ? 'icon' : 'full';
    // immediate local preview while the upload runs
    const reader = new FileReader();
    reader.onload = () => setLogoPreview((current) => ({ ...current, [slot]: typeof reader.result === 'string' ? reader.result : '' }));
    reader.readAsDataURL(file);
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('slot', slot);
      const res = await api.postForm<{ slot: string; path: string }>('/t2/settings/organization/logo', form);
      // The upload persists server-side immediately; patch both saved + draft so it shows the
      // stored URL and does not register as an unsaved change.
      setSaved((current) => ({ ...current, identity: { ...current.identity, [key]: res.path } }));
      setDraft((current) => ({ ...current, identity: { ...current.identity, [key]: res.path } }));
      // v11.8.5.2: also patch the shared org query the sidebar reads so the tenant
      // logo refreshes immediately (no full page reload).
      queryClient.setQueryData<OrganizationSettings>(['t2-organization-settings'], (old) =>
        old ? { ...old, identity: { ...old.identity, [key]: res.path } } : old);
      setLogoPreview((current) => ({ ...current, [slot]: undefined }));
      showToast('Logo updated');
    } catch {
      setLogoPreview((current) => ({ ...current, [slot]: undefined }));
      showToast('Could not upload that image');
    }
  }

  async function removeLogo(key: 'logoIconPath' | 'logoFullPath') {
    const slot = key === 'logoIconPath' ? 'icon' : 'full';
    try { await api.delete(`/t2/settings/organization/logo?slot=${slot}`); } catch { /* ignore */ }
    setSaved((current) => ({ ...current, identity: { ...current.identity, [key]: null } }));
    setDraft((current) => ({ ...current, identity: { ...current.identity, [key]: null } }));
    // v11.8.5.2: refresh the sidebar so it falls back to the monogram tile immediately.
    queryClient.setQueryData<OrganizationSettings>(['t2-organization-settings'], (old) =>
      old ? { ...old, identity: { ...old.identity, [key]: null } } : old);
    setLogoPreview((current) => ({ ...current, [slot]: undefined }));
    showToast('Logo removed');
  }

  function copyTenantUrl() {
    if (!draft.identity.tenantUrl) return;
    navigator.clipboard?.writeText(draft.identity.tenantUrl);
    showToast('VoiceSpectrum URL copied.');
  }

  function sectionDirty(orgSection: OrgSection) {
    if (orgSection === 'identity') return isIdentityDirty;
    if (orgSection === 'hours') return isHoursDirty;
    if (orgSection === 'locations') return false;   // v12.10.26 (#2141): each location saves from its own drawer
    return isHolidaysDirty;
  }

  function saveSection(orgSection: OrgSection) {
    setErrorMessage('');
    if (orgSection === 'identity') saveIdentity.mutate(draft.identity);
    if (orgSection === 'hours') {
      if (isMainHoursDirty) saveHours.mutate(draft.hours);
      if (dirtyLocHourIds.length > 0) saveLocHours.mutate(dirtyLocHourIds);   // v12.10.26 (#2141)
    }
    if (orgSection === 'holidays') saveHolidays.mutate(draft.holidays);
  }

  function discardSection(orgSection: OrgSection) {
    if (orgSection === 'identity') {
      setDraft((current) => ({ ...current, identity: cloneSettings(saved).identity }));
      setLogoPreview({});
    }
    if (orgSection === 'hours') { setDraft((current) => ({ ...current, hours: cloneSettings(saved).hours })); setLocHoursDraft({}); }   // v12.10.26 (#2141)
    if (orgSection === 'holidays') setDraft((current) => ({ ...current, holidays: cloneSettings(saved).holidays }));
    setErrorMessage('');
  }

  // Workflow now uses the common settings chrome (search + cfg-nav); only the grid is exempt.
  const isAreaView = activeArea !== 'grid';
  // v12.10.9.4 (#1335 F7): the sticky bar - which cards are unsaved right now, and how many.
  const domDirtyCards = useDirtyCards('.cfg-content', isAreaView && heroDirty);
  // v12.10.18 (#1866): the workflow page is ONE card on screen but many parts underneath - count what the workflow says changed
  // (each intent on its own), so disabling Text in four intents reads "4 unsaved changes", not "1".
  const dirtyCards = workflowActive && workflowState?.changes?.length ? workflowState.changes : domDirtyCards;
  const unsavedCount = Math.max(1, dirtyCards.length);
  const unsavedNames = dirtyCards.length ? dirtyCards.map((c) => c.title).join(' and ').replace(/ and (?=.* and )/g, ', ') : copy.title;
  const heroSaving = saving || !!secState?.saving || (workflowActive && !!workflowState?.saving);   // v12.10.18 (#1866)
  const areaBlocked = isAreaView && activeArea !== 'security' && !areaVisible(activeArea);   // v12.10.9 (#1253)

  // v12.2.38.0 (#112): search must work from INSIDE a section too — match areas by title/subtitle/section
  // names/keywords (same haystack as the grid) and offer a jump list under the search box.
  // v12.4.16 (#519): the field index is part of the haystack now - see areaMatchesQuery.
  const areaSearchMatches = useMemo(() => {
    const q = gridQuery.trim().toLowerCase();
    if (!q) return [];
    return visibleAreas.filter((area) => areaMatchesQuery(area, q));
  }, [gridQuery, visibleAreas]);

  // v12.10.9: the search row on its own, so Security can put its own page head under it.
  const commandRow = (
    <div className="settings-command-row">
      <button type="button" className="settings-hd-back" onClick={() => changeArea('grid')} aria-label="Back to Settings">
        <SettingsGear /><span>Settings</span>
      </button>
      <div className="settings-search-wrap">
      <label className="settings-searchbox">
        <SearchIcon className="settings-search-ic" />
        <input
          ref={searchRef}
          type="search"
          placeholder="Search settings..."
          value={gridQuery}
          onChange={(e) => setGridQuery(e.target.value)}
        />
        <kbd>Ctrl K</kbd>
      </label>
      {/* v12.2.38.0 (#112): in an area view, typing surfaces a jump list of matching settings areas. */}
      {isAreaView && gridQuery.trim() && (
        <div className="settings-search-results" role="listbox">
          {areaSearchMatches.length === 0 ? (
            <p className="settings-search-empty">No settings match “{gridQuery.trim()}”.</p>
          ) : areaSearchMatches.map((area) => (
            <button
              key={area.id}
              type="button"
              className={`settings-search-hit${area.id === activeArea ? ' is-current' : ''}`}
              onClick={() => { const q = gridQuery.trim().toLowerCase(); changeArea(area.id); setGridQuery(''); flashSearchHit(q); }}
            >
              <span className="settings-search-hit-ic">{AREA_ICONS[area.id]}</span>
              <span className="settings-search-hit-text"><strong>{area.title}</strong><small>{area.subtitle}</small></span>
            </button>
          ))}
        </div>
      )}
      </div>
    </div>
  );

  const header = (
    <div className="settings-sticky-head">
      {commandRow}
      {/* v12.2.36.0 (#192): hero shown for workflow too (it now reports save state up like every section). */}
      {(
        <header className="settings-hero">
          <div className="settings-hero-row">
            <h1>{copy.title}</h1>
            <div className="settings-global-actions">
              <button className="settings-secondary" type="button" disabled={!heroDirty || saving} onClick={() => setConfirmDiscard(true)}>Discard draft</button>
              <button className="settings-primary" type="button" disabled={!heroDirty || saving} onClick={heroSave}>
                {saving ? 'Saving...' : 'Save all changes'}
              </button>
            </div>
          </div>
          <p className="settings-hero-desc">{copy.description}</p>
        </header>
      )}
      {needsOrganizationData && isLoading && <div className="settings-loading">Loading settings...</div>}
      {needsOrganizationData && error && (
        <div className="settings-error">Organization settings could not be loaded. Check the API response before editing settings.</div>
      )}
      {saveMessage && <div className="settings-success">{saveMessage}</div>}
      {errorMessage && <div className="settings-error">{errorMessage}</div>}
    </div>
  );

  return (
    <div className={`settings-org-page settings-view-${activeArea === 'grid' ? 'grid' : 'area'}`}>
      {activeArea === 'grid' && (
        <>
          {header}
          <SettingsGrid onChoose={changeArea} organizationDirty={isDirty} query={gridQuery} areas={visibleAreas} />
        </>
      )}

      {isAreaView && (
        <div className="cfg-body">
          <ConfigAreasNav
            activeArea={activeArea}
            activeSection={activeSection}
            sectionDirty={sectionDirty}
            organizationDirty={isDirty}
            aiDirty={aiActive ? (aiState?.dirty ?? null) : null}
            aiAnyDirty={aiAnyDirty}
            callDirty={callActive ? (callState?.dirty ?? null) : null}
            callAnyDirty={callAnyDirty}
            relDirty={relActive ? (relState?.dirty ?? null) : null}
            relAnyDirty={relAnyDirty}
            kbDirty={kbActive ? (kbState?.dirty ?? null) : null}
            kbAnyDirty={kbAnyDirty}
            secDirty={secActive ? (secState?.dirty ?? null) : null}
            secAnyDirty={secAnyDirty}
            securityPage={securityPage}
            onSecurityPage={setSecurityPage}
            areas={visibleAreas}
            sectionVisible={sectionVisible}
            commDirty={commActive ? (commState?.dirty ?? null) : null}
            commAnyDirty={commAnyDirty}
            txDirty={txActive ? (txState?.dirty ?? null) : null}
            txAnyDirty={txAnyDirty}
            pzDirty={pzActive ? (pzState?.dirty ?? null) : null}
            pzAnyDirty={pzAnyDirty}
            intDirty={intActive ? (intState?.dirty ?? null) : null}
            intAnyDirty={intAnyDirty}
            onArea={changeArea}
            onSection={scrollToSection}
            onSectionIndex={scrollToSectionIndex}
            activeSubIndex={activeSubIndex}
            query={gridQuery}
          />
          <div className="cfg-content">
            {activeArea !== 'security' && header}
            {/* v12.10.9 (#1253, UI principles §19): an area reached by URL that this person cannot open says so. */}
            {areaBlocked && (
              <div className="vs-sec sec-page"><div className="sc-empty"><b>{currentArea?.title ?? 'This area'} isn’t part of your groups</b><span>Ask someone who manages users and groups to give you access.</span>
                <button type="button" className="sc-secondary" onClick={() => changeArea('grid')}>Back to Settings</button></div></div>
            )}
            {securityHub && (
              <div className="vs-sec sec-page">
                <div className="settings-sticky-head">{commandRow}
                  <header className="settings-hero">
                    <div className="sec-crumb"><button type="button" className="sec-crumb-a" onClick={() => changeArea('grid')}>Settings</button> › Security</div>
                    <div className="settings-hero-top"><h1>Security</h1></div>
                    <p className="settings-hero-desc">Sign-in rules, the people who can sign in, what each group can open, and VoiceSpectrum Support’s access.</p>
                  </header>
                </div>
                <section className="settings-card-grid" aria-label="Security">
                  {securityPages.map((p) => (
                    <button key={p.key} type="button" className="settings-area-card" onClick={() => setSecurityPage(p.key)}>
                      <span className="settings-area-glyph"><Ic k={p.key === 'platform' ? 'shieldOk' : p.key === 'users' ? 'users' : 'lock'} /></span>
                      <span>
                        <strong>{p.label}</strong>
                        <small>{p.key === 'platform' ? 'Sign-in rules, sessions, 2-step, Support access' : p.key === 'users' ? 'Who can sign in, their groups, invites' : 'What each group can see and do'}</small>
                      </span>
                      <span className="settings-card-arrow" aria-hidden="true"><ChevR /></span>
                    </button>
                  ))}
                </section>
              </div>
            )}
            {activeArea === 'security' && !securityHub && (
              <SecurityArea
                page={securityPage}
                onPage={setSecurityPage}
                renderHeader={(hero) => (
                  <div className="settings-sticky-head">{commandRow}
                    {/* v12.10.9.3 (#1328): back to the Security tiles */}
                    <div className="sec-crumb"><button type="button" className="sec-crumb-a" onClick={() => changeArea('grid')}>Settings</button> › <button type="button" className="sec-crumb-a" onClick={showSecurityTiles}>Security</button> › {SECURITY_PAGES.find((x) => x.key === securityPage)?.label}</div>
                    {hero}
                  </div>
                )}
                orgName={draft.identity.displayName || draft.identity.legalName || 'your organization'}
                onStateChange={handleSecState}
              />
            )}
            {!areaBlocked && activeArea === 'workflow' && (
              <div className="cfg-workflow-embed">
                <WorkflowModalSnapshotPage onStateChange={handleWorkflowState} />
              </div>
            )}
            {!areaBlocked && activeArea === 'organization' && !isLoading && !error && (
              <OrganizationSections
                draft={draft}
                updateIdentity={updateIdentity}
                updateHour={updateHour}
                selectLogo={selectLogo}
                removeLogo={removeLogo}
                logoPreview={logoPreview}
                tenantInitial={(draft.identity.displayName || draft.identity.legalName || claims?.tenant_slug || 'W').slice(0, 1).toUpperCase()}
                copyTenantUrl={copyTenantUrl}
                holidayYear={holidayYear}
                setHolidayYear={setHolidayYear}
                holidaysForYear={holidaysForYear}
                holidayYears={draft.holidays.years}
                updateHoliday={updateHoliday}
                addHoliday={addHoliday}
                removeHoliday={removeHoliday}
                sectionDirty={sectionDirty}
                saveSection={saveSection}
                discardSection={discardSection}
                saving={saving}
                showToast={showToast}
                locations={orgLocations}
                hoursLoc={hoursLoc}
                onHoursLoc={(id) => setHoursLocId(id)}
                hoursForLoc={hoursLoc ? (locHoursDraft[hoursLoc.id] ?? locHoursSaved[hoursLoc.id] ?? []) : null}
                updateLocHour={updateLocHour}
                dirtyLocHourIds={dirtyLocHourIds}
                onOpenIdentity={() => scrollToSection('identity')}
                canEditLocations={sectionCanEdit('s:Organization:Locations')}
              />
            )}
            {!areaBlocked && activeArea === 'ai' && <AiAgentSections onStateChange={handleAiState} />}
            {!areaBlocked && activeArea === 'call' && <CallHandlingSections onStateChange={handleCallState} />}
            {!areaBlocked && activeArea === 'reliability' && <ReliabilitySections onStateChange={handleRelState} />}
            {!areaBlocked && activeArea === 'knowledge' && <KnowledgeBaseSections onStateChange={handleKbState} />}
            {!areaBlocked && activeArea === 'communication' && <CommunicationSections onStateChange={handleCommState} />}
            {!areaBlocked && activeArea === 'texting' && <TextMessagingSections onStateChange={handleTxState} />}
            {!areaBlocked && activeArea === 'personalization' && <PersonalizationSections key="pz" part="personalization" onStateChange={handlePzState} />}
            {!areaBlocked && activeArea === 'vocabulary' && <PersonalizationSections key="vocab" part="vocabulary" onStateChange={handlePzState} />}
            {!areaBlocked && activeArea === 'integrations' && <IntegrationsSections onStateChange={handleIntState} />}
            {activeArea !== 'organization' && activeArea !== 'workflow' && activeArea !== 'ai' && activeArea !== 'call' && activeArea !== 'reliability' && activeArea !== 'knowledge' && activeArea !== 'security' && activeArea !== 'communication' && activeArea !== 'texting' && activeArea !== 'personalization' && activeArea !== 'vocabulary' && activeArea !== 'integrations' && <PlaceholderContent area={currentArea} />}
          </div>
        </div>
      )}

      {/* v12.10.9.4 (#1335 F7): sticky bar on every Settings page while anything is unsaved. */}
      {/* v12.10.10.1 (#1428): not while a workflow card drawer is open - drawer work never shows in the bar (#1407 rule). */}
      {isAreaView && heroDirty && !(workflowActive && workflowState?.drawerOpen) && (
        <UnsavedBar cards={dirtyCards} fallbackTitle={copy.title} saving={heroSaving} onSave={heroSave} onDiscard={() => setConfirmDiscard(true)} />
      )}

      {(pendingArea || pendingPath) && (
        /* v12.3.12 (#322): act on the ACTIVE section, not only the Organization draft.
           v12.10.9.4 (#1335, UI-PROTO-T40 F7): "Discard your changes?" - Stay / Discard and leave. */
        <UnsavedDialog title="Discard your changes?" body={`You have ${changesText(unsavedCount)} on this page.`}
          cancelLabel="Stay" discardLabel="Discard and leave"
          onCancel={() => { setPendingArea(null); setPendingPath(null); }} onDiscard={heroDiscard} saving={heroSaving} />
      )}

      {/* v12.4.0 (#390): the same guard for the Discard button itself. Cancel and Esc keep the draft - M4's
          rule is that Esc always means put it back - and Save is offered, because someone reaching for Discard
          has often just realised they wanted the opposite. */}
      {confirmDiscard && (
        <UnsavedDialog
          title={`Discard ${changesText(unsavedCount).replace(' unsaved', '')}?`}
          body={`${unsavedNames} go${dirtyCards.length === 1 ? 'es' : ''} back to what is saved.`}
          cancelLabel="Keep editing" discardLabel="Discard"
          onCancel={() => setConfirmDiscard(false)}
          onDiscard={() => { setConfirmDiscard(false); heroDiscard(); }}
          saving={heroSaving} />
      )}

      {/* v12.10.9 (#1259): Your account - opened by openYourAccount() (profile menu, Users) or /configuration/account. */}
      <YourAccountHost openOnMount={section === 'account'} onClosed={() => { if (section === 'account') navigate('/settings', { replace: true }); }} />

      {toastMessage && (
        <div className="settings-toast-wrap" role="status" aria-live="polite">
          <div className="settings-toast"><CheckIcon /> {toastMessage}</div>
        </div>
      )}
    </div>
  );
}

function SettingsGrid({ onChoose, organizationDirty, query, areas: allowed }: {
  onChoose: (area: SettingsArea) => void; organizationDirty: boolean; query: string; areas: typeof SETTINGS_AREAS;
}) {
  // GG1 (v12.1.30.0): live, case-insensitive filter of the area cards. Match against the area
  // title, subtitle/description, and its section names (AREA_SECTIONS) so typing e.g. "session"
  // (a Platform section) or "voicemail" (an AI Agent section) surfaces the owning area. When the
  // query is empty every area shows, so the default 3-up grid layout is unchanged.
  const q = query.trim().toLowerCase();
  // v12.4.16 (#519): also match the field index, so an internal name like "slot normalization" surfaces the area
  // that owns the field even though that wording appears nowhere on the card.
  const areas = q ? allowed.filter((area) => areaMatchesQuery(area, q)) : allowed;   // v12.10.9: only areas this person may open

  // v12.10.9.3 (#1328): the Security card is a card like the others (no inline links) - it opens the Security tiles.
  return (
    <section className="settings-card-grid" aria-label="Settings areas">
      {areas.map((area) => (
        <button key={area.id} className="settings-area-card" type="button" onClick={() => onChoose(area.id)}>
          <span className="settings-area-glyph">{AREA_ICONS[area.id]}</span>
          <span>
            <strong>
              {area.title}
              {area.id === 'organization' && organizationDirty && <span className="settings-card-dirty">Unsaved</span>}
            </strong>
            <small>{area.id === 'security' ? 'Sign-in, sessions, users, user groups, support access' : area.subtitle}</small>
          </span>
          <span className="settings-card-arrow" aria-hidden="true"><ChevR /></span>
        </button>
      ))}
      {q && areas.length === 0 && (
        <p className="settings-grid-empty">No settings areas match “{query.trim()}”.</p>
      )}
    </section>
  );
}

function ConfigAreasNav(props: {
  activeArea: SettingsArea;
  activeSection: OrgSection;
  sectionDirty: (section: OrgSection) => boolean;
  organizationDirty: boolean;
  aiDirty: AiDirtyMap | null;
  aiAnyDirty: boolean;
  callDirty: CallDirtyMap | null;
  callAnyDirty: boolean;
  relDirty: ReliabilityDirtyMap | null;
  relAnyDirty: boolean;
  kbDirty: KbDirtyMap | null;
  kbAnyDirty: boolean;
  secDirty: Record<SecurityPageKey, boolean> | null;   // v12.10.9
  secAnyDirty: boolean;
  securityPage: SecurityPageKey;
  onSecurityPage: (p: SecurityPageKey) => void;
  areas: typeof SETTINGS_AREAS;
  sectionVisible: (area: SettingsArea, index: number) => boolean;
  commDirty: Record<CommunicationSectionKey, boolean> | null;
  commAnyDirty: boolean;
  txDirty: Record<TextingSectionKey, boolean> | null;   // v12.10.26 (#T154)
  txAnyDirty: boolean;
  pzDirty: PzDirtyMap | null;
  pzAnyDirty: boolean;
  intDirty: IntDirtyMap | null;
  intAnyDirty: boolean;
  onArea: (area: SettingsArea) => void;
  onSection: (section: OrgSection) => void;
  onSectionIndex: (i: number) => void;   // v12.2.40.0 (#229): generic scroll for non-org areas
  activeSubIndex: number;                 // v12.2.40.0 (#229)
  query?: string;   // v12.2.38.0 (#203): highlight the matching section while searching
}) {
  const navQuery = (props.query ?? '').trim().toLowerCase();
  return (
    <aside className="cfg-nav" aria-label="Configuration areas">
      <button className="cfg-back" type="button" onClick={() => props.onArea('grid')}>
        <span className="ic"><SettingsGear /></span>
        <span className="lab">Settings</span>
      </button>
      {props.areas.map((area) => {
        const open = area.id === props.activeArea;
        const subs = AREA_SECTIONS[area.id];
        const areaDirty = (area.id === 'organization' && props.organizationDirty) || (area.id === 'ai' && props.aiAnyDirty) || (area.id === 'call' && props.callAnyDirty) || (area.id === 'reliability' && props.relAnyDirty) || (area.id === 'knowledge' && props.kbAnyDirty) || (area.id === 'security' && props.secAnyDirty) || (area.id === 'communication' && props.commAnyDirty) || (area.id === 'texting' && props.txAnyDirty) || ((area.id === 'personalization' || area.id === 'vocabulary') && area.id === props.activeArea && props.pzAnyDirty) || (area.id === 'integrations' && props.intAnyDirty);
        return (
          <div key={area.id} className={`area${open ? ' open' : ''}`}>
            <button className="area-btn" type="button" onClick={() => props.onArea(area.id)}>
              <span className="ic">{AREA_ICONS[area.id]}</span>
              <span className="lab">{area.title}</span>
              {areaDirty && <span className="areadot" aria-label="Unsaved changes" />}
              <span className="chev"><ChevR /></span>
            </button>
            {open && subs.length > 0 && (
              <div className="subs">
                {subs.map((label, index) => {
                  if (!props.sectionVisible(area.id, index)) return null;   // v12.10.9 (#1253): no access -> not in the menu
                  // v12.10.9: Security's sub-items LOAD PAGES (Platform · Users · User groups) - prototype scNavPatch.
                  if (area.id === 'security') {
                    const page = SECURITY_PAGES.find((p) => p.label === label);
                    if (!page) return null;
                    const on = props.securityPage === page.key;
                    return (
                      <button key={label} type="button" className={`sub${on ? ' on' : ''}`} aria-current={on ? 'page' : undefined} onClick={() => props.onSecurityPage(page.key)}>
                        <span>{label}</span>
                        {!!props.secDirty?.[page.key] && <span className="d" aria-label="Unsaved changes" />}
                      </button>
                    );
                  }
                  const orgSection = area.id === 'organization' ? ORG_SECTION_ORDER[index] : undefined;
                  // v12.2.38.0 (#203): highlight a section that matches the search; otherwise the org active
                  // section, otherwise (non-org areas) the FIRST section of the open area so nav is never blank.
                  const queryHit = navQuery.length > 0 && label.toLowerCase().includes(navQuery);
                  const active = queryHit
                    ? true
                    : (area.id === 'organization'
                        ? (!!orgSection && orgSection === props.activeSection)
                        : (open && index === props.activeSubIndex));
                  const aiKey = area.id === 'ai' ? AI_SECTION_KEYS[index] : undefined;
                  const callKey = area.id === 'call' ? CALL_SECTION_KEYS[index] : undefined;
                  const relKey = area.id === 'reliability' ? RELIABILITY_SECTION_KEYS[index] : undefined;
                  const kbKey = area.id === 'knowledge' ? KB_SECTION_KEYS[index] : undefined;
                  const commKey = area.id === 'communication' ? COMM_SECTION_KEYS[index] : undefined;
                  const txKey = area.id === 'texting' ? TEXTING_SECTION_KEYS[index] : undefined;   // v12.10.26 (#T154)
                  const pzKey = area.id === 'personalization' ? PERSONALIZATION_SECTION_KEYS[index] : area.id === 'vocabulary' ? VOCABULARY_SECTION_KEYS[index] : undefined;
                  const intKey = area.id === 'integrations' ? INTEGRATIONS_SECTION_KEYS[index] : undefined;
                  const dirty = (!!orgSection && props.sectionDirty(orgSection)) || (!!aiKey && !!props.aiDirty?.[aiKey]) || (!!callKey && !!props.callDirty?.[callKey]) || (!!relKey && !!props.relDirty?.[relKey]) || (!!kbKey && !!props.kbDirty?.[kbKey]) || (!!commKey && !!props.commDirty?.[commKey]) || (!!txKey && !!props.txDirty?.[txKey]) || (!!pzKey && !!props.pzDirty?.[pzKey]) || (!!intKey && !!props.intDirty?.[intKey]);
                  return (
                    <button
                      key={label}
                      type="button"
                      className={`sub${active ? ' on' : ''}`}
                      onClick={() => { if (orgSection) props.onSection(orgSection); else props.onSectionIndex(index); }}
                    >
                      <span>{label}</span>
                      {dirty && <span className="d" aria-label="Unsaved changes" />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </aside>
  );
}

interface OrgSectionsProps {
  // v12.10.26 (#2141): Organization › Locations + the Hours & locale pills
  locations: import('./organization/LocationsSection').PracticeLocation[];
  hoursLoc: import('./organization/LocationsSection').PracticeLocation | null;
  onHoursLoc: (id: number) => void;
  hoursForLoc: LocationHour[] | null;
  updateLocHour: (locId: number, dayOfWeek: number, patch: Partial<BusinessHour>) => void;
  dirtyLocHourIds: number[];
  onOpenIdentity: () => void;
  canEditLocations: boolean;
  draft: OrganizationSettings;
  updateIdentity: <K extends keyof OrganizationIdentity>(key: K, value: OrganizationIdentity[K]) => void;
  updateHour: (dayOfWeek: number, patch: Partial<BusinessHour>) => void;
  selectLogo: (event: ChangeEvent<HTMLInputElement>, key: 'logoIconPath' | 'logoFullPath') => void;
  removeLogo: (key: 'logoIconPath' | 'logoFullPath') => void;
  logoPreview: { icon?: string; full?: string };
  tenantInitial: string;
  copyTenantUrl: () => void;
  holidayYear: number;
  setHolidayYear: (year: number) => void;
  holidaysForYear: { item: HolidayItem; index: number }[];
  holidayYears: number[];
  updateHoliday: (index: number, patch: Partial<HolidayItem>) => void;
  addHoliday: (name: string, date: string) => void;
  removeHoliday: (index: number) => void;
  sectionDirty: (section: OrgSection) => boolean;
  saveSection: (section: OrgSection) => void;
  discardSection: (section: OrgSection) => void;
  saving: boolean;
  showToast: (message: string) => void;
}

function OrganizationSections(props: OrgSectionsProps) {
  return (
    <section className="organization-panel">
      <SettingsSection id={SECTION_DOM_ID.identity} title="Identity" description="Name, industry, contact, branding, and primary identifiers." dirty={props.sectionDirty('identity')} saving={props.saving} onSave={() => props.saveSection('identity')} onDiscard={() => props.discardSection('identity')}>
        {/* v12.10.28 (#2205): the Main-location note is gone (Tushar 11/1 "we don't need this"). */}
        <IdentityForm draft={props.draft} updateIdentity={props.updateIdentity} selectLogo={props.selectLogo} removeLogo={props.removeLogo} logoPreview={props.logoPreview} tenantInitial={props.tenantInitial} copyTenantUrl={props.copyTenantUrl} />
      </SettingsSection>
      {/* v12.10.26 (#2141): Settings › Organization › Locations (list + drawer; saves per drawer) */}
      <LocationsCard onOpenIdentity={props.onOpenIdentity} canEdit={props.canEditLocations} />
      <SettingsSection id={SECTION_DOM_ID.hours} title="Hours & locale" description="Timezone and weekly operating hours." dirty={props.sectionDirty('hours')} saving={props.saving} onSave={() => props.saveSection('hours')} onDiscard={() => props.discardSection('hours')}>
        {/* v12.10.26 (#2141): one pill per location (only with 2+), main selected by default; the schedule shown is that location's. */}
        <LocationPills locations={props.locations} selectedId={props.hoursLoc?.id ?? props.locations.find((l) => l.isMain)?.id ?? null} onSelect={props.onHoursLoc} dirtyIds={props.dirtyLocHourIds} />
        <HoursForm
          draft={props.hoursLoc && props.hoursForLoc ? { ...props.draft, hours: props.hoursForLoc as BusinessHour[] } : props.draft}
          updateHour={props.hoursLoc ? (day, patch) => props.updateLocHour(props.hoursLoc!.id, day, patch) : props.updateHour}
          updateIdentity={props.updateIdentity} showToast={props.showToast} />
        {props.locations.length > 1 && (
          <div className="loc-hint loc-hours-foot">The timezone is practice-wide - the same for every location. Holiday dates close every location (practice-wide).</div>
        )}
      </SettingsSection>
      <SettingsSection id={SECTION_DOM_ID.holidays} title="Holiday dates" description="Public holidays load automatically for your region. Toggle the ones you observe, or add custom closures." dirty={props.sectionDirty('holidays')} saving={props.saving} onSave={() => props.saveSection('holidays')} onDiscard={() => props.discardSection('holidays')}>
        <HolidayForm holidayYear={props.holidayYear} setHolidayYear={props.setHolidayYear} holidayYears={props.holidayYears} holidaysForYear={props.holidaysForYear} updateHoliday={props.updateHoliday} addHoliday={props.addHoliday} removeHoliday={props.removeHoliday} />
      </SettingsSection>
    </section>
  );
}

function SettingsSection(props: { id: string; title: string; description: string; dirty: boolean; saving: boolean; onSave: () => void; onDiscard: () => void; children: ReactNode }) {
  return (
    <article id={props.id} className={`settings-section-card${props.dirty ? ' dirty' : ''}`}>
      <header className="settings-section-header">
        <div className="settings-section-headrow">
          <h2>{props.title}</h2>
          <div className="settings-actions">
            <button type="button" className="settings-secondary" onClick={props.onDiscard} disabled={!props.dirty || props.saving}>Discard</button>
            <button type="button" className="settings-primary" onClick={props.onSave} disabled={!props.dirty || props.saving}>{props.saving ? 'Saving...' : 'Save section'}</button>
          </div>
        </div>
        <p>{props.description}</p>
      </header>
      {props.children}
    </article>
  );
}

function IdentityForm(props: {
  draft: OrganizationSettings;
  updateIdentity: <K extends keyof OrganizationIdentity>(key: K, value: OrganizationIdentity[K]) => void;
  selectLogo: (event: ChangeEvent<HTMLInputElement>, key: 'logoIconPath' | 'logoFullPath') => void;
  removeLogo: (key: 'logoIconPath' | 'logoFullPath') => void;
  logoPreview: { icon?: string; full?: string };
  tenantInitial: string;
  copyTenantUrl: () => void;
}) {
  const identity = props.draft.identity;
  return (
    <div className="settings-form">
      <div className="settings-grid-two">
        <Field label="Business name" hint="legal / full name" value={identity.legalName} onChange={(value) => props.updateIdentity('legalName', value)} />
        <Field label="Display name" hint="shown in app & to callers" value={identity.displayName} onChange={(value) => props.updateIdentity('displayName', value)} />
        <Field label="Website" icon={<GlobeIcon />} validate="url" value={identity.websiteUrl ?? ''} onChange={(value) => props.updateIdentity('websiteUrl', value)} />
        <div className="settings-field settings-logo-field">
          <span>Logo <em className="settings-hint">shown in the sidebar (PNG or SVG). Click a box to upload.</em></span>
          <div className="logo-drop">
            <LogoSlot variant="sq" label="Icon · 256×256" monogram={props.tenantInitial} preview={props.logoPreview.icon} storedSrc={identity.logoIconPath} onPick={(event) => props.selectLogo(event, 'logoIconPath')} onRemove={() => props.removeLogo('logoIconPath')} />
            <LogoSlot variant="wd" label="Full logo · up to 1024×256" preview={props.logoPreview.full} storedSrc={identity.logoFullPath} onPick={(event) => props.selectLogo(event, 'logoFullPath')} onRemove={() => props.removeLogo('logoFullPath')} />
          </div>
        </div>
        {/* v12.9.26 (#949): Address takes ONE column and Primary language sits in the slot beside it, as the #884
            mockup placed it - no empty cell left in the grid. */}
        <AddressAutocomplete
          half
          value={identity.addressText ?? ''}
          verified={identity.addressVerified}
          onPick={(p) => {
            props.updateIdentity('addressText', p.addressText);
            props.updateIdentity('addressLatitude', p.addressLatitude);
            props.updateIdentity('addressLongitude', p.addressLongitude);
            props.updateIdentity('addressVerified', p.addressVerified);
          }}
        />
        {/* v12.9.22 (#884) - BDR-015 R1. His words, pointing at this slot: "you can place primary language here".
            It sits with Primary email and Primary phone because it is another "Primary ___" organization field.
            Spoken by every pre-routing card until the caller's language is detected at classify. */}
        <label className="settings-field">
          <span>Primary language</span>
          <select
            value={identity.primaryLanguage ?? ''}
            onChange={(event) => props.updateIdentity('primaryLanguage', event.target.value)}
            disabled={!(identity.enabledLanguages ?? []).length}
          >
            {(identity.enabledLanguages ?? []).map((code) => (
              <option key={code} value={code}>{langLabel({ code, displayName: '' })}</option>
            ))}
            {!(identity.enabledLanguages ?? []).length && <option value="">No languages enabled yet</option>}
          </select>
          {/* v12.10.11 (#1457): say where languages are turned on instead of only greying out. */}
          {!(identity.enabledLanguages ?? []).length && (
            <small className="settings-hint">Turn languages on in <a href={areaPath('ai')}>AI Agent › Languages &amp; Voices</a>; the first one becomes the primary.</small>
          )}
        </label>
        <Field label="Primary email" icon={<MailIcon />} validate="email" value={identity.primaryEmail ?? ''} onChange={(value) => props.updateIdentity('primaryEmail', value)} />
        <Field label="Primary phone" icon={<PhoneIcon />} validate="phone" value={identity.primaryPhone ?? ''} onChange={(value) => props.updateIdentity('primaryPhone', formatPhone(value))} />
        <Field label="Primary contact - name" value={identity.primaryContactName ?? ''} onChange={(value) => props.updateIdentity('primaryContactName', value)} />
        <Field label="Primary contact - role" value={identity.primaryContactRole ?? ''} onChange={(value) => props.updateIdentity('primaryContactRole', value)} />
        <label className="settings-field">
          <span>Industry</span>
          <select value={identity.industry} onChange={(event) => props.updateIdentity('industry', event.target.value)}>
            {INDUSTRIES.map((industry) => <option key={industry} value={industry}>{industry}</option>)}
          </select>
          {identity.industry === 'Other' && (
            <input className="settings-ind-other" placeholder="Type your industry" value={identity.industryOther ?? ''} onChange={(event) => props.updateIdentity('industryOther', event.target.value)} />
          )}
        </label>
        <div className="settings-field settings-readonly-url">
          <span>VoiceSpectrum URL <em className="settings-hint">your VoiceSpectrum address (read-only)</em></span>
          <div className="settings-copyfield">
            <input value={identity.tenantUrl ?? 'Tenant URL not available'} readOnly />
            <button type="button" onClick={props.copyTenantUrl}>Copy</button>
          </div>
        </div>
      </div>
      <p className="settings-token-note">These fields are tokenized and can be referenced in AI Assistant configuration.</p>
    </div>
  );
}

function Field(props: { label: string; hint?: string; icon?: ReactNode; value: string; onChange: (value: string) => void; placeholder?: string; validate?: 'url' | 'email' | 'phone'; className?: string }) {
  const showError = !!(props.validate && props.value.trim().length > 0 && !validateValue(props.validate, props.value));
  const input = (
    <input className={showError ? 'err' : undefined} type="text" value={props.value} placeholder={props.placeholder} onChange={(event) => props.onChange(event.target.value)} />
  );
  const errorText = props.validate === 'email' ? 'Enter a valid email address.' : props.validate === 'url' ? 'Enter a valid URL.' : 'Enter a valid phone number.';
  return (
    <label className={`settings-field${props.className ? ` ${props.className}` : ''}`}>
      <span>{props.label}{props.hint && <em className="settings-hint">{props.hint}</em>}</span>
      {props.icon ? <span className="settings-with-ic">{props.icon}{input}</span> : input}
      {props.validate && <small className={`settings-errmsg${showError ? ' show' : ''}`}>{errorText}</small>}
    </label>
  );
}

function LogoSlot(props: { variant: 'sq' | 'wd'; label: string; monogram?: string; preview?: string; storedSrc?: string | null; onPick: (event: ChangeEvent<HTMLInputElement>) => void; onRemove?: () => void }) {
  const src = props.preview ?? (isImageSrc(props.storedSrc) ? mediaUrl(props.storedSrc) : undefined);
  const isSet = !!src;
  return (
    <div className="logo-slot-wrap">
      <label className={`logo-slot${isSet ? ' set' : ''}`}>
        <input type="file" accept="image/png,image/svg+xml,image/jpeg,image/webp" onChange={props.onPick} />
        <span className={`lf-box ${props.variant}`}>
          {src ? <img src={src} alt="logo" /> : props.variant === 'sq' ? <span className="lf-tile">{props.monogram ?? 'S'}</span> : <span className="lf-ph"><ImageIcon /></span>}
          <span className="lf-over"><UploadIcon /></span>
        </span>
        <span className="lf-lab">{props.label}</span>
        <span className={`lf-ok${props.preview ? ' show' : ''}`}><CheckIcon /> Updated</span>
      </label>
      {isSet && props.onRemove && <button type="button" className="lf-remove" onClick={props.onRemove}>Remove</button>}
    </div>
  );
}

function HoursForm(props: {
  draft: OrganizationSettings;
  updateIdentity: <K extends keyof OrganizationIdentity>(key: K, value: OrganizationIdentity[K]) => void;
  updateHour: (dayOfWeek: number, patch: Partial<BusinessHour>) => void;
  showToast: (message: string) => void;
}) {
  const [breakDay, setBreakDay] = useState<number | null>(null);
  const [breakDraft, setBreakDraft] = useState<{ start: string; end: string }>({ start: '12:00', end: '13:00' });
  const [copyDay, setCopyDay] = useState<number | null>(null);
  const [copyTargets, setCopyTargets] = useState<number[]>([]);
  const [flash, setFlash] = useState<number[]>([]);

  useEffect(() => {
    if (breakDay === null && copyDay === null) return;
    function onDocClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      if (!target.closest('.break-pop') && !target.closest('.break-add') && !target.closest('.bc-edit')) setBreakDay(null);
      if (!target.closest('.day-copy-menu') && !target.closest('.day-copy')) setCopyDay(null);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [breakDay, copyDay]);

  const hours = [...props.draft.hours].sort((a, b) => a.dayOfWeek - b.dayOfWeek);

  function openBreak(day: number) {
    const hour = props.draft.hours.find((h) => h.dayOfWeek === day);
    setBreakDraft({ start: hour?.breakStartTime || '12:00', end: hour?.breakEndTime || '13:00' });
    setCopyDay(null);
    setBreakDay(day);
  }
  function saveBreak(day: number) {
    if (!breakDraft.start || !breakDraft.end) return;
    props.updateHour(day, { breakEnabled: true, breakStartTime: breakDraft.start, breakEndTime: breakDraft.end });
    setBreakDay(null);
  }
  function removeBreak(day: number) {
    props.updateHour(day, { breakEnabled: false, breakStartTime: null, breakEndTime: null });
  }
  function openCopy(day: number) {
    setBreakDay(null);
    setCopyTargets([]);
    setCopyDay((current) => (current === day ? null : day));
  }
  function toggleTarget(day: number) {
    setCopyTargets((current) => (current.includes(day) ? current.filter((d) => d !== day) : [...current, day]));
  }
  function applyCopy(sourceDay: number) {
    const source = props.draft.hours.find((h) => h.dayOfWeek === sourceDay);
    if (!source) return;
    const targets = [...copyTargets];
    targets.forEach((day) => {
      props.updateHour(day, { isOpen: source.isOpen, openTime: source.openTime, closeTime: source.closeTime, breakEnabled: source.breakEnabled, breakStartTime: source.breakStartTime, breakEndTime: source.breakEndTime });
    });
    setCopyDay(null);
    setCopyTargets([]);
    setFlash(targets);
    window.setTimeout(() => setFlash([]), 1000);
    props.showToast(`${WEEKDAYS[sourceDay - 1]} copied to ${targets.length} day${targets.length === 1 ? '' : 's'}`);
  }

  return (
    <div className="settings-form">
      <div className="settings-grid-two settings-tz-row">
        <label className="settings-field">
          <span>Timezone</span>
          <select value={props.draft.identity.timezoneId} onChange={(event) => props.updateIdentity('timezoneId', event.target.value)}>
            {TIMEZONES.map((zone) => <option key={zone.value} value={zone.value}>{zone.label}</option>)}
          </select>
        </label>
        <div />
      </div>
      <div className="hours-head"><label className="hours-head-label">Weekly schedule</label></div>
      <div className="days-wrap">
        {hours.map((hour) => {
          const day = hour.dayOfWeek;
          const dayName = WEEKDAYS[day - 1];
          const hasBreak = hour.breakEnabled && hour.breakStartTime && hour.breakEndTime;
          return (
            <div className={`day-card${hour.isOpen ? '' : ' closed'}${flash.includes(day) ? ' flash' : ''}`} key={day}>
              <div className="day-top">
                <button type="button" className="day-name" onClick={() => props.updateHour(day, { isOpen: !hour.isOpen })}><span className="day-dot" />{dayName}</button>
                <div className="day-ctrls">
                  <button type="button" className="day-copy" onClick={() => openCopy(day)} aria-label={`Copy ${dayName} to other days`} title="Copy to other days"><CopyIcon /></button>
                  <span className="day-state">{hour.isOpen ? 'Open' : 'Closed'}</span>
                  <button type="button" className="day-toggle" aria-pressed={hour.isOpen} aria-label={`Toggle ${dayName}`} onClick={() => props.updateHour(day, { isOpen: !hour.isOpen })}><span className="knob" /></button>
                </div>
              </div>
              {hour.isOpen && (
                <div className="day-body">
                  <div className="time-grid">
                    <div className="time-cell"><span className="tl">Open</span><input type="time" value={hour.openTime ?? '09:00'} onChange={(event) => props.updateHour(day, { openTime: event.target.value })} /></div>
                    <div className="time-cell"><span className="tl">Close</span><input type="time" value={hour.closeTime ?? '17:00'} onChange={(event) => props.updateHour(day, { closeTime: event.target.value })} /></div>
                  </div>
                  <div className="break-line">
                    {hasBreak ? (
                      <span className="break-chip">
                        <CoffeeIcon />
                        <span className="bc-txt">Break · {fmt12(hour.breakStartTime)} – {fmt12(hour.breakEndTime)}</span>
                        <button type="button" className="bc-edit" onClick={() => openBreak(day)} aria-label="Edit break"><EditIcon /></button>
                        <button type="button" className="bc-rm" onClick={() => removeBreak(day)} aria-label="Remove break"><XIcon /></button>
                      </span>
                    ) : (
                      <button type="button" className="break-add" onClick={() => openBreak(day)}><CoffeeIcon /> Add a break</button>
                    )}
                  </div>
                </div>
              )}
              {breakDay === day && (
                <div className="break-pop open">
                  <div className="bp-h">Break time · {dayName}</div>
                  <div className="bp-row">
                    <div className="bp-field"><span className="bl">From</span><input type="time" value={breakDraft.start} onChange={(event) => setBreakDraft((d) => ({ ...d, start: event.target.value }))} /></div>
                    <div className="bp-field"><span className="bl">To</span><input type="time" value={breakDraft.end} onChange={(event) => setBreakDraft((d) => ({ ...d, end: event.target.value }))} /></div>
                  </div>
                  <div className="bp-acts">
                    <button type="button" className="bp-cancel" onClick={() => setBreakDay(null)}>Cancel</button>
                    <button type="button" className="bp-save" onClick={() => saveBreak(day)} disabled={!breakDraft.start || !breakDraft.end}>Save</button>
                  </div>
                </div>
              )}
              {copyDay === day && (
                <div className="day-copy-menu open">
                  <div className="dcm-h">Copy {dayName} to…</div>
                  {hours.filter((h) => h.dayOfWeek !== day).map((h) => {
                    const target = h.dayOfWeek;
                    const on = copyTargets.includes(target);
                    return (
                      <button type="button" key={target} className={`dcm-tgt${on ? ' on' : ''}`} onClick={() => toggleTarget(target)}>
                        <span className="cb"><CheckIcon /></span> {WEEKDAYS[target - 1]}
                      </button>
                    );
                  })}
                  <button type="button" className="dcm-apply" disabled={copyTargets.length === 0} onClick={() => applyCopy(day)}>Apply to {copyTargets.length} day{copyTargets.length === 1 ? '' : 's'}</button>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <p className="settings-token-note">After-hours behavior is configured in Call Handling and uses these hours.</p>
    </div>
  );
}

function HolidayForm(props: {
  holidayYear: number;
  setHolidayYear: (year: number) => void;
  holidayYears: number[];
  holidaysForYear: { item: HolidayItem; index: number }[];
  updateHoliday: (index: number, patch: Partial<HolidayItem>) => void;
  addHoliday: (name: string, date: string) => void;
  removeHoliday: (index: number) => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [holName, setHolName] = useState('');
  const [holDate, setHolDate] = useState('');
  const nameRef = useRef<HTMLInputElement>(null);

  useEffect(() => { if (modalOpen) nameRef.current?.focus(); }, [modalOpen]);

  function closeModal() {
    setModalOpen(false);
    setHolName('');
    setHolDate('');
  }
  function addHol() {
    if (!holName.trim() || !holDate) return;
    props.addHoliday(holName.trim(), holDate);
    closeModal();
  }

  return (
    <div className="settings-form">
      <div className="year-tabs">
        {props.holidayYears.map((year) => (
          <button key={year} type="button" className={props.holidayYear === year ? 'on' : ''} onClick={() => props.setHolidayYear(year)}>{year}</button>
        ))}
      </div>
      <div className="hol-grid">
        {props.holidaysForYear.map(({ item, index }) => {
          const custom = item.type === 'custom';
          return (
            <div key={`${item.date}-${index}`} className={`hol${item.observed ? ' on' : ''}`} role="button" tabIndex={0} onClick={() => props.updateHoliday(index, { observed: !item.observed })} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); props.updateHoliday(index, { observed: !item.observed }); } }}>
              <div>
                <div className="nm">{item.name}{custom && <span className="custom-tag">Custom</span>}</div>
                <div className="dt">{formatHolidayDate(item.date)}</div>
              </div>
              <span className="chk"><CheckIcon /></span>
              {custom && (
                <button type="button" className="rm" aria-label={`Remove ${item.name}`} onClick={(event) => { event.stopPropagation(); props.removeHoliday(index); }}><XIcon /></button>
              )}
            </div>
          );
        })}
        <button type="button" className="hol-add" onClick={() => setModalOpen(true)}><PlusIcon /> Add custom date</button>
      </div>
      <p className="settings-token-note">On holidays, calls are handled using your after-hours behavior.</p>

      {modalOpen && (
        <div className="settings-modal-scrim show" onMouseDown={(event) => { if (event.target === event.currentTarget) closeModal(); }}>
          <div className="settings-org-modal" role="dialog" aria-modal="true" aria-labelledby="add-holiday-title">
            <h4 id="add-holiday-title">Add custom holiday</h4>
            <p>Add a closure date specific to this organization. It will appear alongside public holidays.</p>
            <div className="mrow"><label htmlFor="holName">Name</label><input id="holName" ref={nameRef} value={holName} onChange={(event) => setHolName(event.target.value)} placeholder="e.g. Founders Day" /></div>
            <div className="mrow"><label htmlFor="holDate">Date</label><input id="holDate" type="date" value={holDate} onChange={(event) => setHolDate(event.target.value)} /></div>
            <div className="mact">
              <button type="button" className="mc" onClick={closeModal}>Cancel</button>
              <button type="button" className="ma" onClick={addHol} disabled={!holName.trim() || !holDate}>Add holiday</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function PlaceholderContent({ area }: { area?: { title: string; subtitle: string } }) {
  return (
    <section className="settings-section-card settings-area-placeholder">
      <header className="settings-section-header">
        <div className="settings-section-headrow"><h2>{area?.title ?? 'Settings area'}</h2></div>
        <p>{area?.subtitle}</p>
      </header>
      <div className="settings-placeholder-frame">Section content frame</div>
    </section>
  );
}

// v12.10.9.4 (#1335): title / button words per route (UI-PROTO-T40 F7); Save is offered only when onSave is passed.
function UnsavedDialog(props: { onCancel: () => void; onDiscard: () => void; onSave?: () => void; saving: boolean; body?: string; title?: string; cancelLabel?: string; discardLabel?: string }) {
  // v12.4.0 (#390): Esc maps to CANCEL, never Discard. SPEC_modals_v1_3, M4: "Esc always means put it back."
  // The dialog had no key handler at all, so Esc did nothing on a guard whose whole job is protecting work.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); props.onCancel(); } };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [props]);
  return (
    <div className="settings-modal-backdrop" role="presentation">
      <section className="settings-modal" role="dialog" aria-modal="true" aria-labelledby="unsaved-title">
        <h2 id="unsaved-title">{props.title ?? 'Unsaved changes'}</h2>
        {/* v12.4.0 (#390): the wording follows the route in. "Leaving now would discard them" is true when you
            navigated away; it is not what happened when you pressed Discard. */}
        <p>{props.body ?? 'You have changes here that have not been saved yet. Leaving now would discard them.'}</p>
        <div className="settings-actions">
          <button type="button" className="settings-secondary" onClick={props.onCancel}>{props.cancelLabel ?? 'Cancel'}</button>
          <button type="button" className={props.onSave ? 'settings-secondary' : 'settings-danger'} onClick={props.onDiscard}>{props.discardLabel ?? 'Discard'}</button>
          {props.onSave && <button type="button" className="settings-primary" onClick={props.onSave} disabled={props.saving}>{props.saving ? 'Saving...' : 'Save'}</button>}
        </div>
      </section>
    </div>
  );
}
